<template>
  <div class="container mb-5 mt-lg-5 d-flex flex-column gap-3 w-100">
    <div v-if="!errorForm" class="container mb-5 mt-lg-0 d-flex flex-column gap-3 w-100">
      <!-- Contenedor de la imagen o icono -->
      <div class="d-flex justify-content-center align-items-center card-img-top rounded-4 position-relative" style="height: 200px">
        <!-- Mostrar la imagen si ya está cargada -->
        <img v-if="form.PortadaUrl" :src="form.PortadaUrl" alt="Imagen seleccionada" class="rounded-4 w-100 h-100 sombra object-fit-cover">
        
        <!-- Mostrar el icono si no hay imagen -->
        <i v-else class="bi bi-image fs-1 texto-principal"></i>
      </div>

      <!-- Campos del Formulario -->
      <div class="d-flex flex-row align-items-start align-items-md-center justify-content-center gap-2">
        <router-link to="/formularios" class="btn d-flex align-items-center justify-content-center p-0 pt-1 tooltip-container">
          <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 12H18M6 12L11 7M6 12L11 17" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="tooltip-text">{{ $t('volver') }}</span>
        </router-link>
        <h2 class="m-0 text-wrap w-100" for="nombreFormulario">{{ form.NombreFormulario }}</h2>
      </div>

      <div class="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center gap-3">
        <div class="d-flex flex-row align-items-center justify-content-start gap-2 flex-wrap">
          <div v-if="form.Anonimo" class="d-flex flex-row gap-2 sombra-sm align-items-center justify-content-start bg-goethe-accent-claro-2 rounded-4 p-2 px-3" style="min-height: 42px;">
            <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
              <path class="stroke-principal" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 7.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm0 0 .211-.106a4 4 0 0 1 3.578 0L14 7.5m0 0a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0Zm-2 6.303c5-3 5 3.5 9 1.767-1 4.233-6 4.233-9 1.233-3 3-8 3-9-1.233 4 1.733 4-4.767 9-1.767Z"/>
            </svg>
            <p class="m-0">{{ $t('anonimo') }}</p>
          </div>
          <div v-if="form.ConAccesoRestringido" class="d-flex flex-row gap-1 sombra-sm align-items-center justify-content-center tooltip-container bg-goethe-accent-claro-2 rounded-4 p-1 px-3" style="min-height: 42px;">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 22h14a2 2 0 002-2V7.5L14.5 2H6a2 2 0 00-2 2v4"/>
              <path d="M14 2v6h6"/>
              <path d="M 3.501 18 L 6.501 15 L 3.501 12"/>
              <path d="M 6.49 12.007 L 9.49 15.007 L 6.49 18.007" style="transform-box: fill-box; transform-origin: 50% 50%;" transform="matrix(-1, 0, 0, -1, 0, 0.000001)"/>
            </svg>
            <p class="m-0 p-0">{{ $t('conAccesoRestringido') }}</p>
          </div>
          <div v-if="form.ConEdicionDeCompletado" class="d-flex flex-row gap-1 sombra-sm align-items-center justify-content-center tooltip-container bg-goethe-accent-claro-2 rounded-4 p-1 px-3" style="min-height: 42px;">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" class="stroke-principal" xmlns="http://www.w3.org/2000/svg">
              <path d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M21 21H12" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <p class="m-0 p-0">{{ $t('conEdicionDeCompletado') }}</p>
            <!-- Divider Vertical -->
            <div class="col-12 border border-goethe-accent-claro" style="height: 30px; width:1px"></div>
            <div class="d-flex flex-row gap-1 align-items-center">
              <p class="m-0 p-0">{{ $t((form.AQuienEdita || '').replace(/\s+/g, '').toLowerCase()) }}</p>
              
              <div class="tooltip-container d-flex justify-content-center align-items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" viewBox="0 0 24 24" fill="none" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="16" x2="12" y2="12"></line>
                  <line x1="12" y1="8" x2="12" y2="8"></line>
                </svg>
                <span class="tooltip-text-left text-left" style="max-width: 50vw; width: 250px;">
                  <p class="m-0 fs-8 texto-principal">{{ $t('queRespuestasPuedenEditar') + ': ' + $t((form.AQuienEdita || '').replace(/\s+/g, '').toLowerCase()) }}</p>
                </span>
              </div>
            </div>
          </div>

          <div v-if="form.ConVisualizacionRestringida" class="d-flex flex-row gap-2 sombra-sm align-items-center justify-content-start bg-goethe-accent-claro-2 rounded-4 p-2 px-3" style="min-height: 42px;">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 4L9.87868 9.87868M20 20L14.1213 14.1213M9.87868 9.87868C9.33579 10.4216 9 11.1716 9 12C9 13.6569 10.3431 15 12 15C12.8284 15 13.5784 14.6642 14.1213 14.1213M9.87868 9.87868L14.1213 14.1213M6.76821 6.76821C4.72843 8.09899 2.96378 10.026 2 11.9998C3.74646 15.5764 8.12201 19 11.9998 19C13.7376 19 15.5753 18.3124 17.2317 17.2317M9.76138 5.34717C10.5114 5.12316 11.2649 5 12.0005 5C15.8782 5 20.2531 8.42398 22 12.0002C21.448 13.1302 20.6336 14.2449 19.6554 15.2412" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <p class="m-0">{{ $t('conVisualizacionRestringida') }}</p>
          </div>

          <div v-if="form.ConAutorizaciones" class="d-flex flex-row gap-2 sombra-sm align-items-center justify-content-start bg-goethe-accent-claro-2 rounded-4 p-2 px-3" style="min-height: 42px;">
            <svg fill="none" width="25" height="25" class="stroke-principal icon line-color" viewBox="0 0 24 24" id="done-music-collection" data-name="Line Color" xmlns="http://www.w3.org/2000/svg">
              <polyline id="secondary" points="7 9.63 9.25 11.88 13 8.13" style="fill: none;  stroke-linecap: round; stroke-linejoin: round; stroke-width: 2;"></polyline>
              <rect id="primary" x="3" y="3" width="14" height="14" rx="1" style="fill: none;  stroke-linecap: round; stroke-linejoin: round; stroke-width: 2;"></rect>
              <path id="primary-2" data-name="primary" d="M7,21H17a4,4,0,0,0,4-4V5" style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2;"></path>
            </svg>
            <p class="m-0">{{ $t('conAutorizaciones') }}</p>
          </div>

          <div v-if="form.Habilitado == false" class="d-flex flex-row gap-2 sombra-sm align-items-center justify-content-start bg-goethe-accent-claro-2 rounded-4 p-2 px-3" style="min-height: 42px;">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.99902 3L20.999 21M9.8433 9.91364C9.32066 10.4536 8.99902 11.1892 8.99902 12C8.99902 13.6569 10.3422 15 11.999 15C12.8215 15 13.5667 14.669 14.1086 14.133M6.49902 6.64715C4.59972 7.90034 3.15305 9.78394 2.45703 12C3.73128 16.0571 7.52159 19 11.9992 19C13.9881 19 15.8414 18.4194 17.3988 17.4184M10.999 5.04939C11.328 5.01673 11.6617 5 11.9992 5C16.4769 5 20.2672 7.94291 21.5414 12C21.2607 12.894 20.8577 13.7338 20.3522 14.5" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <p class="m-0">{{ $t('deshabilitado') }}</p>
          </div>

          <div v-if="form.FormPublicoATodos == true" class="d-flex flex-row gap-2 sombra-sm align-items-center justify-content-start bg-goethe-accent-claro-2 rounded-4 p-2 px-3" style="min-height: 42px;">
            <svg width="22" height="22" viewBox="0 0 24 24" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.0007 12C15.0007 13.6569 13.6576 15 12.0007 15C10.3439 15 9.00073 13.6569 9.00073 12C9.00073 10.3431 10.3439 9 12.0007 9C13.6576 9 15.0007 10.3431 15.0007 12Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12.0012 5C7.52354 5 3.73326 7.94288 2.45898 12C3.73324 16.0571 7.52354 19 12.0012 19C16.4788 19 20.2691 16.0571 21.5434 12C20.2691 7.94291 16.4788 5 12.0012 5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <p class="m-0">{{ $t('formPublico') }}</p>
          </div>

          <div v-if="form.ConRespuesta" class="d-flex flex-row gap-2 sombra-sm align-items-center justify-content-center bg-goethe-accent-claro-2 rounded-4 p-1 px-3" style="min-height: 42px;">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" class="stroke-principal" xmlns="http://www.w3.org/2000/svg">
              <path d="M 9.364 12.06 L 17.595 12.06 M 9.364 15.353 L 13.48 15.353 M 20.888 21.114 L 18.152 19.746 C 17.944 19.643 17.84 19.591 17.731 19.555 C 17.635 19.522 17.536 19.499 17.435 19.485 C 17.321 19.468 17.205 19.468 16.973 19.468 L 8.706 19.468 C 7.784 19.468 7.323 19.468 6.971 19.289 C 6.661 19.132 6.409 18.88 6.251 18.569 C 6.072 18.217 6.072 17.756 6.072 16.834 L 6.072 10.579 C 6.072 9.657 6.072 9.196 6.251 8.844 C 6.409 8.534 6.661 8.282 6.971 8.124 C 7.323 7.945 7.784 7.945 8.706 7.945 L 18.254 7.945 C 19.176 7.945 19.636 7.945 19.989 8.124 C 20.298 8.282 20.55 8.534 20.708 8.844 C 20.888 9.196 20.888 9.657 20.888 10.579 L 20.888 21.114 Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M 4.858 7.257 L 13.089 7.257 M 4.858 10.55 L 5.993 10.55 M 16.352 7.88 L 7.593 7.866 C 7.385 7.763 6.5 8.346 6.359 8.549 C 6.091 8.934 6.093 9.535 6.064 10.105 C 6.05 10.378 6.044 14.304 6.053 14.695 L 4.2 14.665 C 3.278 14.665 2.817 14.665 2.465 14.486 C 2.155 14.329 1.903 14.077 1.745 13.766 C 1.566 13.414 1.566 12.953 1.566 12.031 L 1.566 5.776 C 1.566 4.854 1.566 4.393 1.745 4.041 C 1.903 3.731 2.155 3.479 2.465 3.321 C 2.817 3.142 3.278 3.142 4.2 3.142 L 13.748 3.142 C 14.67 3.142 15.13 3.142 15.483 3.321 C 15.792 3.479 16.044 3.731 16.202 4.041 C 16.382 4.393 16.382 4.854 16.382 5.776 L 16.352 7.88 Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <p class="m-0 p-0">{{ $t('conRespuesta') }}</p>
            <!-- Divider Vertical -->
            <div class="col-12 border border-goethe-accent-claro" style="height: 30px; width:1px"></div>
            <div class="d-flex flex-row gap-1 align-items-center">
              <p class="m-0 p-0">{{ $t(form.AQuienesResponden.toLowerCase()) }}</p>
              
              <div class="tooltip-container d-flex justify-content-center align-items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" viewBox="0 0 24 24" fill="none" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="16" x2="12" y2="12"></line>
                  <line x1="12" y1="8" x2="12" y2="8"></line>
                </svg>
                <span class="tooltip-text-left text-left" style="max-width: 50vw; width: 250px;">
                  <p class="m-0 fs-8 texto-principal">{{ $t('quienesLesApareceParaResponder') + ' ' + $t(form.AQuienesResponden.toLowerCase()) }}</p>
                </span>
              </div>
            </div>
          </div>
        </div>
        
        <div class="d-flex flex-row sombra-sm align-items-center justify-content-start gap-1 bg-goethe-accent-claro-2 rounded-4 px-2" style="height: 42px;">
          <router-link :to="'/formularios/completar?idForm=' + idForm" class="btn p-2 d-flex flex-row align-items-center justify-content-center tooltip-container" @click="addRedirectUrl()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24"  height="24"  viewBox="0 0 24 24" fill="none" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 22h14a2 2 0 002-2V7.5L14.5 2H6a2 2 0 00-2 2v4" />
              <path d="M14 2v6h6" />
              <path d="M2 15h10" style="stroke: rgb(44, 169, 188);"/>
              <path d="M9 18l3-3-3-3" style="stroke: rgb(44, 169, 188);"/>
            </svg>
            <span class="tooltip-text">{{ $t('completar') }}</span>
          </router-link>
          <!-- Divider Vertical -->
          <div class="col-12 border border-goethe-accent-claro" style="height: 30px; width:1px"></div>

          <button v-if="userPermission == 'Editor'" class="btn p-2 d-flex flex-row align-items-center justify-content-center tooltip-container border-0" @click="editForm(idForm)">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" class="stroke-principal" xmlns="http://www.w3.org/2000/svg">
              <path d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M21 21H12" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="tooltip-text">{{ $t('editar') }}</span>
          </button>

          <!-- Divider Vertical -->
          <div v-if="userPermission == 'Editor'" class="col-12 border border-goethe-accent-claro" style="height: 30px; width:1px"></div>
          <button v-if="userPermission == 'Editor'" class="btn p-2 d-flex flex-row align-items-center justify-content-center tooltip-container border-0" @click="toggleAccessMenu(idForm)">
            <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" class="stroke-principal icon line-color" data-name="Line Color">
              <g class="layer">
                <path d="m18.22,17.99l4,0m-2,-2l0,4" fill="#000" id="secondary" stroke=" rgb(44, 169, 188)" stroke-linecap=" round" stroke-linejoin=" round" stroke-width="2"/>
                <path d="m16.15,14.09a4.71,4.71 0 0 0 -1,-0.1l-6,0a5,5 0 0 0 -5,5l0,1s2,2 8,2a22,22 0 0 0 3,-0.19c0.35,0 0.69,-0.1 1,-0.17" fill=" none" id="primary"  stroke-linecap=" round" stroke-linejoin=" round" stroke-width="2"/>
                <path d="m7.08,10.67a5,5 0 0 0 -5,5l0,1" fill=" none" id="svg_1"  stroke-linecap=" round" stroke-linejoin=" round" stroke-width="2"/>
                <path d="m12.36,13.47c-2.71,0 -4.91,-2.2 -4.91,-4.92c0,-2.71 2.2,-4.91 4.91,-4.91c2.72,0 4.92,2.2 4.92,4.91c0,2.72 -2.2,4.92 -4.92,4.92z" fill="none" id="svg_9" opacity="undefined"  stroke-width="2" transform="matrix(1 0 0 1 0 0)"/>
                <line fill="none" id="svg_11"  stroke-linecap=" round" stroke-linejoin=" round" stroke-width="2" x1="2.1" x2="4.01" y1="17.06" y2="17.18"/>
                <path d="m6.46,9.28c-1.26,0.03 -2.88,-1.57 -2.88,-3.57c0,-1.99 1.62,-3.61 3.61,-3.61c2,0 3.47,1.8 3.07,1.98c-0.39,0.18 -1.2,0.63 -1.72,1.23c-0.52,0.6 -0.72,1.06 -1,2.09c-0.27,1.02 0.17,1.86 -1.09,1.88z" fill="none" id="svg_3" opacity="undefined"  stroke-width="2"/>
              </g>
            </svg>
            <span class="tooltip-text">{{ $t('darAcceso') }}</span>
          </button>

          <!-- Divider Vertical -->
          <div v-if="userPermission == 'Editor'" class="col-12 border border-goethe-accent-claro" style="height: 30px; width:1px"></div>
          <button v-if="userPermission == 'Editor'" class="btn p-2 d-flex flex-row align-items-center justify-content-center tooltip-container border-0" @click="showDeleteMenu = true">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-principal">
              <path d="M10 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M14 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M4 7H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="tooltip-text">{{ $t('eliminar') }}</span>
          </button>

          <!-- Divider Vertical -->
          <div v-if="userPermission == 'Editor'" class="col-12 border border-goethe-accent-claro" style="height: 30px; width:1px"></div>
          <button v-if="userPermission == 'Editor'" class="btn p-2 d-flex flex-row align-items-center justify-content-center tooltip-container border-0" @click="downloadCsvForm">
            <svg width="20" height="20" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="fill-principal">
              <path d="M13.5 3.5H14V3.29289L13.8536 3.14645L13.5 3.5ZM10.5 0.5L10.8536 0.146447L10.7071 0H10.5V0.5ZM6.5 6.5V6H6V6.5H6.5ZM6.5 8.5H6V9H6.5V8.5ZM8.5 8.5H9V8H8.5V8.5ZM8.5 10.5V11H9V10.5H8.5ZM10.5 9.5H10V9.70711L10.1464 9.85355L10.5 9.5ZM11.5 10.5L11.1464 10.8536L11.5 11.2071L11.8536 10.8536L11.5 10.5ZM12.5 9.5L12.8536 9.85355L13 9.70711V9.5H12.5ZM2.5 6.5V6H2V6.5H2.5ZM2.5 10.5H2V11H2.5V10.5ZM2 5V1.5H1V5H2ZM13 3.5V5H14V3.5H13ZM2.5 1H10.5V0H2.5V1ZM10.1464 0.853553L13.1464 3.85355L13.8536 3.14645L10.8536 0.146447L10.1464 0.853553ZM2 1.5C2 1.22386 2.22386 1 2.5 1V0C1.67157 0 1 0.671573 1 1.5H2ZM1 12V13.5H2V12H1ZM2.5 15H12.5V14H2.5V15ZM14 13.5V12H13V13.5H14ZM12.5 15C13.3284 15 14 14.3284 14 13.5H13C13 13.7761 12.7761 14 12.5 14V15ZM1 13.5C1 14.3284 1.67157 15 2.5 15V14C2.22386 14 2 13.7761 2 13.5H1ZM9 6H6.5V7H9V6ZM6 6.5V8.5H7V6.5H6ZM6.5 9H8.5V8H6.5V9ZM8 8.5V10.5H9V8.5H8ZM8.5 10H6V11H8.5V10ZM10 6V9.5H11V6H10ZM10.1464 9.85355L11.1464 10.8536L11.8536 10.1464L10.8536 9.14645L10.1464 9.85355ZM11.8536 10.8536L12.8536 9.85355L12.1464 9.14645L11.1464 10.1464L11.8536 10.8536ZM13 9.5V6H12V9.5H13ZM5 6H2.5V7H5V6ZM2 6.5V10.5H3V6.5H2ZM2.5 11H5V10H2.5V11Z"/>
            </svg>
            <span class="tooltip-text">{{ $t('exportarResultados') }}</span>
          </button>

          <!-- Divider Vertical -->
          <div v-if="userPermission == 'Editor'" class="col-12 border border-goethe-accent-claro" style="height: 30px; width:1px"></div>
          <button v-if="userPermission == 'Editor'" class="btn p-2 d-flex flex-row align-items-center justify-content-center tooltip-container border-0" @click="habilitarFormulario">
            <!-- Ojo abierto -->
            <svg v-if="form.Habilitado == false" width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.0007 12C15.0007 13.6569 13.6576 15 12.0007 15C10.3439 15 9.00073 13.6569 9.00073 12C9.00073 10.3431 10.3439 9 12.0007 9C13.6576 9 15.0007 10.3431 15.0007 12Z" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12.0012 5C7.52354 5 3.73326 7.94288 2.45898 12C3.73324 16.0571 7.52354 19 12.0012 19C16.4788 19 20.2691 16.0571 21.5434 12C20.2691 7.94291 16.4788 5 12.0012 5Z" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <!-- Ojo cerrado  -->
            <svg v-if="form.Habilitado == true || form.Habilitado == null" width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.99902 3L20.999 21M9.8433 9.91364C9.32066 10.4536 8.99902 11.1892 8.99902 12C8.99902 13.6569 10.3422 15 11.999 15C12.8215 15 13.5667 14.669 14.1086 14.133M6.49902 6.64715C4.59972 7.90034 3.15305 9.78394 2.45703 12C3.73128 16.0571 7.52159 19 11.9992 19C13.9881 19 15.8414 18.4194 17.3988 17.4184M10.999 5.04939C11.328 5.01673 11.6617 5 11.9992 5C16.4769 5 20.2672 7.94291 21.5414 12C21.2607 12.894 20.8577 13.7338 20.3522 14.5" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span v-if="form.Habilitado == false" class="tooltip-text">{{ $t('habilitar') }}</span>
            <span v-if="form.Habilitado == true || form.Habilitado == null" class="tooltip-text">{{ $t('deshabilitar') }}</span>
          </button>

          <!-- Divider Vertical -->
          <div v-if="userPermission == 'Editor'" class="col-12 border border-goethe-accent-claro" style="height: 30px; width:1px"></div>
          <button class="btn p-2 d-flex flex-row align-items-center justify-content-center tooltip-container" @click="toggleShareMenu(idForm)">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-principal">
              <path d="M9 12C9 13.3807 7.88071 14.5 6.5 14.5C5.11929 14.5 4 13.3807 4 12C4 10.6193 5.11929 9.5 6.5 9.5C7.88071 9.5 9 10.6193 9 12Z" stroke-width="1.5"/>
              <path d="M14 6.5L9 10" stroke-width="1.5" stroke-linecap="round"/>
              <path d="M14 17.5L9 14" stroke-width="1.5" stroke-linecap="round"/>
              <path d="M19 18.5C19 19.8807 17.8807 21 16.5 21C15.1193 21 14 19.8807 14 18.5C14 17.1193 15.1193 16 16.5 16C17.8807 16 19 17.1193 19 18.5Z" stroke-width="1.5"/>
              <path d="M19 5.5C19 6.88071 17.8807 8 16.5 8C15.1193 8 14 6.88071 14 5.5C14 4.11929 15.1193 3 16.5 3C17.8807 3 19 4.11929 19 5.5Z" stroke-width="1.5"/>
            </svg>
            <span class="tooltip-text">{{ $t('compartir') }}</span>
          </button>
        </div>
      </div>

      <!-- Overlay y menú flotante de confirmación -->
      <div v-if="showDeleteMenu" class="overlay" @click="closeDeleteMenu"></div>
      <div v-if="showDeleteMenu" class="share-menu fondo-principal">
        <div class="close-icon d-flex align-items-center" @click="closeDeleteMenu">
          <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
            <g clip-path="url(#clip0_429_11083)">
              <path d="M7 7.00006L17 17.0001M7 17.0001L17 7.00006" class="stroke-principal" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs>
              <clipPath id="clip0_429_11083">
                <rect width="24" height="24" class="fill-principal"/>
              </clipPath>
            </defs>
          </svg>
        </div>
        <p class="fs-5">¿{{ $t('seguroEliminarForm') }}?</p>
        <div class="d-flex flex-row justify-content-center gap-3">
          <button class="btn btn-danger sombra-sm" @click="deleteForm(idForm)">{{ $t('confirmar') }}</button>
          <button class="btn btn-secondary sombra-sm" @click="closeDeleteMenu">{{ $t('cancelar') }}</button>
        </div>
      </div>

      <!-- Overlay y menú flotante de compartir -->
      <div v-if="showShareMenu" class="overlay" @click="closeShareMenu"></div>
      <div v-if="showShareMenu" class="share-menu fondo-principal">
        <div class="close-icon d-flex align-items-center" @click="closeShareMenu">
          <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_429_11083)">
              <path d="M7 7.00006L17 17.0001M7 17.0001L17 7.00006" class="stroke-principal" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs>
              <clipPath id="clip0_429_11083">
                <rect width="24" height="24" class="fill-principal"/>
              </clipPath>
            </defs>
          </svg>
        </div>
        <p>{{ $t('copiarEnlaceParaCompartir') }}:</p>
        <div class="d-flex flex-row align-items-center">
          <input type="text" v-model="urlCompartir" class="form-control fondo-secundario borde-principal sombra-sm" />
          <div class="tooltip-container">
            <button class="btn pb-2" @click="copyLink(showShareMenu)">
              <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M19.5 16.5L19.5 4.5L18.75 3.75H9L8.25 4.5L8.25 7.5L5.25 7.5L4.5 8.25V20.25L5.25 21H15L15.75 20.25V17.25H18.75L19.5 16.5ZM15.75 15.75L15.75 8.25L15 7.5L9.75 7.5V5.25L18 5.25V15.75H15.75ZM6 9L14.25 9L14.25 19.5L6 19.5L6 9Z" class="fill-principal"/>
              </svg>
            </button>
            <span class="tooltip-text">{{ $t('copiar') }}</span>
          </div>
        </div>
        <p v-if="form.ConRespuesta" class="mt-5">{{ $t('copiarEnlaceParaCompartirParaResponder') }}:</p>
        <div v-if="form.ConRespuesta" class="d-flex flex-row align-items-center">
          <input type="text" v-model="urlCompartirResponder" class="form-control" />
          <div class="tooltip-container">
            <button class="btn pb-2" @click="copyLinkResponder(showShareMenu)">
              <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M19.5 16.5L19.5 4.5L18.75 3.75H9L8.25 4.5L8.25 7.5L5.25 7.5L4.5 8.25V20.25L5.25 21H15L15.75 20.25V17.25H18.75L19.5 16.5ZM15.75 15.75L15.75 8.25L15 7.5L9.75 7.5V5.25L18 5.25V15.75H15.75ZM6 9L14.25 9L14.25 19.5L6 19.5L6 9Z" class="fill-principal"/>
              </svg>
            </button>
            <span class="tooltip-text">{{ $t('copiar') }}</span>
          </div>
        </div>
      </div>

      <!-- Overlay y menú flotante de dar acceso -->
      <div v-if="showAccessMenu" class="overlay" @click="toggleAccessMenu"></div>
      <div v-if="showAccessMenu" class="share-menu d-flex flex-column gap-2 fondo-principal">
        <div class="close-icon d-flex align-items-center" @click="toggleAccessMenu">
          <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_429_11083)">
              <path d="M7 7.00006L17 17.0001M7 17.0001L17 7.00006" class="stroke-principal" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs>
              <clipPath id="clip0_429_11083">
                <rect width="24" height="24" class="fill-principal"/>
              </clipPath>
            </defs>
          </svg>
        </div>

        <p class="fw-bold text-start m-0">{{ $t('agregarPersonas') }}:</p>

        <form @submit.prevent="submit" class="d-flex flex-column gap-2">
          <div class="select-wrapper" style="width: 250px;">
            <select v-model="tipoAcceso" class="form-select sombra-sm texto-principal borde-terciario" required>
              <option value="persona">{{ $t('personaEspecifica') }}</option>
              <option value="grupo">{{ $t('grupo') }}</option>
            </select>
            <svg class="select-icon fill-principal" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
            </svg>
          </div>
          <div v-if="tipoAcceso == 'persona'" class="d-flex flex-row align-items-center gap-2">
            <div class="position-relative w-100 d-flex flex-row">
              <input type="text" v-model="searchQuery" :placeholder="$t('buscarPersona')+'...'" class="form-control w-100 sombra-sm" @input="filterPersonas" required/>
              <ul v-if="filteredPersonas.length > 0" class="list-group position-absolute sombra-sm" style="z-index: 1000; width: 100%; top: 100%;">
                <li v-for="evaluado in filteredPersonas"  :key="evaluado.IdPersona"  class="list-group-item list-group-item-action d-flex flex-column" @click="selectPersona(evaluado)" style="cursor: pointer;">
                  <span class="fs-7">{{ evaluado?.Apellido + ' ' + evaluado?.Nombre }}</span>
                  <span class="fs-7" v-if="evaluado?.Email && evaluado.Email?.length > 0">{{ evaluado.Email[0].email }}</span>
                </li>
              </ul>

              <div v-if="loadingSubmitAcceso" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
                <img src="@/assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
              </div>
            </div>
            <div class="select-wrapper">
              <select style="width: 150px;" v-model="tipoPermiso" class="form-select sombra-sm texto-principal borde-terciario" required>
                <option value="Lector">{{ $t('lector') }}</option>
                <option value="Editor">{{ $t('editor') }}</option>
                <option v-if="form.ConAccesoRestringido" value="Completador">{{ $t('completador') }}</option>
                <option v-if="form.ConRespuesta" value="Respondedor">{{ $t('respondedor') }}</option>
              </select>
              <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
              </svg>
            </div>
            <button type="submit" class="btn btn-success sombra-sm">
              {{ $t('agregar') }}
            </button>
          </div>
          <div v-if="tipoAcceso == 'grupo'" class="d-flex flex-row align-items-center gap-2">
            <div class="position-relative w-100 d-flex flex-row">
              <input type="text" v-model="searchQuery" :placeholder="$t('buscarLista')+'...'" class="form-control w-100 sombra-sm" @input="filterLista" required/>
              <ul v-if="filteredLista.length > 0" class="list-group position-absolute sombra-sm" style="z-index: 1000; width: 100%; top: 100%; max-height: 200px; overflow-y: auto;">
                <li v-for="opcionGrupo in filteredLista" :key="opcionGrupo.IdPersona" class="list-group-item list-group-item-action d-flex flex-column" @click="selectLista(opcionGrupo)" style="cursor: pointer;">
                  <span class="fs-7">{{ opcionGrupo?.Nombre }}</span>
                </li>
              </ul>

              <div v-if="loadingListas" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
                <img src="@/assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
              </div>
            </div>
            <div class="select-wrapper">
              <select style="width: 150px;" v-model="tipoPermiso" class="form-select sombra-sm texto-principal borde-terciario" required>
                <option value="Lector">{{ $t('lector') }}</option>
                <option value="Editor">{{ $t('editor') }}</option>
                <option v-if="form.ConAccesoRestringido" value="Completador">{{ $t('completador') }}</option>
                <option v-if="form.ConRespuesta" value="Respondedor">{{ $t('respondedor') }}</option>
              </select>
              <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
              </svg>
            </div>
            <button type="submit" class="btn btn-success sombra-sm">
              {{ $t('agregar') }}
            </button>
          </div>
          
          <div class="form-check d-flex align-items-center gap-2 ps-1" style="cursor: pointer;">
            <input
              id="checkbox-todos"
              type="checkbox"
              class="checkbox-custom sombra-sm"
              v-model="conEnvio"
            />
            <label for="checkbox-todos" class="form-check-label">
              {{ $t('conEnvioDeEmail') }}
            </label>
          </div>
        </form>
        <svg xmlns="http://www.w3.org/2000/svg" class="d-none">
            <symbol id="exclamation-triangle-fill" viewBox="0 0 16 16">
                <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
            </symbol>
        </svg>
        <div class="alert alert-danger d-flex align-items-center mt-3 mb-0 p-1" v-if="errorMessage!=''" role="alert">
            <svg class="bi flex-shrink-0 mx-2" role="img" aria-label="Danger:" style="width:16px; height:16px"><use xlink:href="#exclamation-triangle-fill" /></svg>
            <p class="m-0">{{ errorMessage }}</p>
        </div>

        <div class="my-1">
          <p class="m-0 fs-8 text-start texto-principal"> - {{ $t('lector') }}: {{ $t('permisosLector') }}</p>
          <p class="m-0 fs-8 text-start texto-principal"> - {{ $t('editor') }}: {{ $t('permisosEditor') }}</p>
          <p v-if="form.ConAccesoRestringido" class="m-0 fs-8 text-start texto-principal"> - {{ $t('completador') }}: {{ $t('permisosCompletador') }}</p>
          <p v-if="form.ConRespuesta" class="m-0 fs-8 text-start texto-principal"> - {{ $t('respondedor') }}: {{ $t('permisosRespondedor') }}</p>
        </div>

        <!-- Divider -->
        <div class="col-12 my-2" style="border-top: 1px solid #ddd; height: 1px"></div>

        <!-- Mostrar la lista de personas con acceso -->
        <p v-if="form.AccesoFormularios.some( af => af.IdLista != null)" class="m-0 fs-6 fw-bold text-start">{{ $t('gruposConAcceso') }}:</p>
        <div style="max-height: 250px; overflow-y: auto; overflow-x: hidden;" class="d-flex flex-column">
          <div v-for="acceso in form.AccesoFormularios.filter( af => af.IdLista != null)" :key="acceso.IdPersona" class="m-0 fs-7 py-1 text-start d-flex justify-content-between hover-row">
            <div class="d-flex flex-column align-items-start">
              <span>{{ acceso.Lista?.Nombre }}</span>
            </div>
            <div class="d-flex flex-row gap-1 align-items-center">
              <div class="select-wrapper">
                <select style="width: 135px;" v-model="acceso.TipoPermiso" class="form-select fs-7 sombra-sm texto-principal" @change="actualizarAcceso(acceso)">
                  <option value="Lector">{{ $t('lector') }}</option>
                  <option value="Editor">{{ $t('editor') }}</option>
                  <option v-if="form.ConAccesoRestringido" value="Completador">{{ $t('completador') }}</option>
                  <option v-if="form.ConRespuesta" value="Respondedor">{{ $t('respondedor') }}</option>
                </select>
                <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
                </svg>
              </div>
              <!-- <button class="btn btn-danger btn-sm ms-2 fs-8" @click="removeAccess(acceso.idPersona)">Eliminar</button> -->
              <button v-if="userPermission == 'Editor'" class="btn p-2 me-1 d-flex flex-row align-items-center justify-content-center tooltip-container border-0" @click="deleteAcceso(acceso)">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-principal">
                  <path d="M10 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M14 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M4 7H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <!-- <span class="tooltip-text">{{ $t('eliminar') }}</span> -->
              </button>
            </div>
          </div>
        </div>
        <p class="m-0 fs-6 fw-bold text-start">{{ $t('personasConAcceso') }}:</p>
        <div style="max-height: 250px; overflow-y: auto; overflow-x: hidden;" class="d-flex flex-column">
          <div class="m-0 fs-7 py-1 text-start d-flex justify-content-between hover-row">
            <div class="d-flex flex-column align-items-start justify-content-center">
              <span>{{ form.IdCreadorNavigation?.Apellido }} {{ form.IdCreadorNavigation?.Nombre }}</span>
            </div>
            <div class="d-flex flex-row gap-1 align-items-center fondo-secundario rounded-2 p-1 px-2 sombra-sm" style="width: 135px; margin-right: 44px;">
              <span>{{ $t('creador') }}</span>
            </div>
          </div>
          <div v-for="acceso in form.AccesoFormularios.filter( af => af.IdPersona != null)" :key="acceso.IdPersona" class="m-0 fs-7 py-1 text-start d-flex justify-content-between hover-row">
            <div class="d-flex flex-column align-items-start">
              <span>{{ acceso.IdPersonaNavigation?.Apellido }} {{ acceso.IdPersonaNavigation?.Nombre }}</span>
              <span v-if="acceso.IdPersonaNavigation.Email && acceso.IdPersonaNavigation.Email.length > 0">
                {{ acceso.IdPersonaNavigation.Email.find(e => e.TipoEmail == "Profesional").email }}
              </span>
            </div>
            <div class="d-flex flex-row gap-1 align-items-center">
              <div class="select-wrapper">
                <select style="width: 135px;" v-model="acceso.TipoPermiso" class="form-select fs-7 sombra-sm texto-principal" @change="actualizarAcceso(acceso)">
                  <option value="Lector">{{ $t('lector') }}</option>
                  <option value="Editor">{{ $t('editor') }}</option>
                  <option v-if="form.ConAccesoRestringido" value="Completador">{{ $t('completador') }}</option>
                  <option v-if="form.ConRespuesta" value="Respondedor">{{ $t('respondedor') }}</option>
                </select>
                <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
                </svg>
              </div>
              <!-- <button class="btn btn-danger btn-sm ms-2 fs-8" @click="removeAccess(acceso.idPersona)">Eliminar</button> -->
              <button v-if="userPermission == 'Editor'" class="btn p-2 me-1 d-flex flex-row align-items-center justify-content-center tooltip-container border-0" @click="deleteAcceso(acceso)">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-principal">
                  <path d="M10 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M14 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M4 7H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <!-- <span class="tooltip-text">{{ $t('eliminar') }}</span> -->
              </button>
            </div>
          </div>
        </div>
      </div>

      <p class="w-100" style="white-space: pre-wrap; word-wrap: break-word;">
        <span v-html="formatDescription(form.Descripcion)"></span>
      </p>

      <div v-if="userPermission == 'Editor'">
        <p class="text-wrap texto-terciario fs-7 w-100 m-0">{{ $t('ultMod') + ' ' + formatDateTime(form.FechaModificacion) + ' ' + (form.IdModificadoPorNavigation ? ' ' + $t('por') + ' ' + form.IdModificadoPorNavigation?.Nombre + ' ' + form.IdModificadoPorNavigation?.Apellido : '') }}</p>
        <!-- <p class="text-wrap texto-terciario fs-7 w-100 m-0">{{ $t('creadoPor') + (form.IdCreadorNavigation ? ' ' + form.IdCreadorNavigation?.Nombre + ' ' + form.IdCreadorNavigation?.Apellido : '') }}</p> -->
      </div>

      <div class="w-100">
        <div class="d-flex justify-content-center rounded-4 overflow-hidden sombra-sm">
          <button
            class="btn-menu texto-principal fondo-terciario fs-5 w-100 d-flex gap-2 py-4"
            :class="{'active-btn': isFirstDivVisible, 'stroke-principal': !isFirstDivVisible}"
            @click="toggleResults(1)"
          >
            <svg width="23" height="23" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 10V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 7V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <rect x="3" y="3" width="18" height="18" rx="2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M8 13L8 17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            {{ $t('graficos') }}
          </button>
          <button
            class="btn-menu texto-principal fondo-terciario fs-5 w-100 d-flex gap-2 py-4"
            :class="{'active-btn': !isFirstDivVisible, 'stroke-principal': isFirstDivVisible}"
            @click="toggleResults(2)"
          >
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path id="Vector" d="M9 17H19M9 12H19M9 7H19M5.00195 17V17.002L5 17.002V17H5.00195ZM5.00195 12V12.002L5 12.002V12H5.00195ZM5.00195 7V7.002L5 7.00195V7H5.00195Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            {{ $t('respuestas') }}
          </button>
        </div>
      </div>


      <div v-if="isFirstDivVisible" class="d-flex flex-column gap-4">
        <div v-for="(observacion, index) in form.Observacions.filter(obs => obs.IdTipoObservacion !== '989bec4b-779d-41b0-8b28-1f1487b59ded' && obs.IdTipoObservacion !== 'bb1c6568-f8ea-42bc-9133-375f86fa2415')" :key="observacion.IdObservacion" class="m-0 p-3 border border-0 fondo-terciario rounded-3 sombra-sm">
          <div>
            <h3>{{ $t('observacion') }}: {{ observacion.NombreObservacion }}</h3>
            <p class="fs-6">{{ $t('tipo') }}: {{ $t(`${ observacion.IdTipoObservacionNavigation.tipoObservacion.replace(/\s+/g, '')}`) }}</p>
            <p class="w-100" style="white-space: pre-wrap;  word-wrap: break-word;">{{ observacion.Descripcion }}</p>
            <!-- Divider -->
            <div class="col-12 my-3" style="border-top: 1px solid #ddd; height: 1px"></div>

            <canvas :id="'observacionChart-' + index" class="chart-canvas text-principal"></canvas>
          </div>
          <!-- Divider -->
          <div class="col-12 my-3" style="border-top: 1px solid #ccc; height: 1px"></div>

          <div class="d-flex flex-row flex-wrap gap-3 align-items-center justify-content-end px-2">

            <button type="button" class="btn p-0 border-0 chart-button" @click="drawChart(observacion, index, 'bar', 'x')">
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V3M15 10V17M7 13V17M19 5V17M11 7V17" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>

            <!-- Divider Vertical -->
            <div class="col-12" style="border-right: 1px solid #ccc; height: 45px; width:1px"></div>

            <button type="button" class="btn p-0 border-0 chart-button" @click="drawChart(observacion, index, 'bar', 'y')">
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 3V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H21M19 15H7M18 7H7M15 11H7" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <!-- Divider Vertical -->
            <div class="col-12" style="border-right: 1px solid #ccc; height: 45px; width:1px"></div>

            <button type="button" class="btn p-0 border-0 chart-button" @click="drawChart(observacion, index, 'line', 'x')">
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 21H6.2C5.07989 21 4.51984 21 4.09202 20.782C3.71569 20.5903 3.40973 20.2843 3.21799 19.908C3 19.4802 3 18.9201 3 17.8V3M7 15L12 9L16 13L21 7" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>

            <!-- Divider Vertical -->
            <div class="col-12" style="border-right: 1px solid #ccc; height: 45px; width:1px"></div>

            <button type="button" class="btn p-0 border-0 chart-button" @click="drawChart(observacion, index, 'line', 'x', true)">
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V3M14.4286 10L12.8153 8.26266C12.408 7.82396 12.2043 7.6046 11.9659 7.52324C11.7565 7.45174 11.5292 7.45174 11.3198 7.52324C11.0814 7.6046 10.8778 7.82396 10.4704 8.26266L7.42753 11.5396C7.26951 11.7098 7.1905 11.7948 7.13411 11.8925C7.0841 11.979 7.04735 12.0726 7.0251 12.1701C7 12.28 7 12.3961 7 12.6283V15.4C7 15.9601 7 16.2401 7.10899 16.454C7.20487 16.6422 7.35785 16.7951 7.54601 16.891C7.75992 17 8.03995 17 8.6 17H18.4C18.9601 17 19.2401 17 19.454 16.891C19.6422 16.7951 19.7951 16.6422 19.891 16.454C20 16.2401 20 15.9601 20 15.4V12.6283C20 12.3961 20 12.28 19.9749 12.1701C19.9526 12.0726 19.9159 11.979 19.8659 11.8925C19.8095 11.7948 19.7305 11.7098 19.5725 11.5396L18.1429 10C17.9623 9.80555 17.872 9.70833 17.7812 9.6458C17.4397 9.41088 16.9888 9.41088 16.6474 9.6458C16.5566 9.70833 16.4663 9.80555 16.2857 10C16.1052 10.1944 16.0149 10.2917 15.924 10.3542C15.5826 10.5891 15.1317 10.5891 14.7903 10.3542C14.6994 10.2917 14.6091 10.1944 14.4286 10Z" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>

            <!-- Divider Vertical -->
            <div class="col-12" style="border-right: 1px solid #ccc; height: 45px; width:1px"></div>

            <button type="button" class="btn p-0 border-0 chart-button" @click="drawChart(observacion, index, 'pie')">
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 10C21 6.13401 17.866 3 14 3V10H21Z" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M11 21C15.4183 21 19 17.4183 19 13H11V5C6.58172 5 3 8.58172 3 13C3 17.4183 6.58172 21 11 21Z" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>

            <!-- Divider Vertical -->
            <div class="col-12" style="border-right: 1px solid #ccc; height: 45px; width:1px"></div>

            <button type="button" class="btn p-0 border-0 chart-button" @click="drawChart(observacion, index, 'doughnut')">
              <svg width="30" height="30" viewBox="-2 -2 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.5 14C3.91015 14 1 11.0899 1 7.5H0C0 11.6421 3.35786 15 7.5 15V14ZM14 7.5C14 11.0899 11.0899 14 7.5 14V15C11.6421 15 15 11.6421 15 7.5H14ZM7.5 1C11.0899 1 14 3.91015 14 7.5H15C15 3.35786 11.6421 0 7.5 0V1ZM7.5 0C3.35786 0 0 3.35786 0 7.5H1C1 3.91015 3.91015 1 7.5 1V0ZM10.197 6.45957L13.697 4.95957L13.303 4.04043L9.80304 5.54043L10.197 6.45957ZM7 0V4.5H8V0H7ZM9.14645 9.85355L12.1464 12.8536L12.8536 12.1464L9.85355 9.14645L9.14645 9.85355ZM7.5 10C6.11929 10 5 8.88071 5 7.5H4C4 9.433 5.567 11 7.5 11V10ZM10 7.5C10 8.88071 8.88071 10 7.5 10V11C9.433 11 11 9.433 11 7.5H10ZM7.5 5C8.88071 5 10 6.11929 10 7.5H11C11 5.567 9.433 4 7.5 4V5ZM7.5 4C5.567 4 4 5.567 4 7.5H5C5 6.11929 6.11929 5 7.5 5V4Z" class="fill-principal stroke-principal" stroke-width="0.5"/>
              </svg>
            </button>
          </div>
        </div>
      </div>


      <!-- Menu Respuestas -->
      <div v-else class="d-flex flex-column gap-3">
        <div class="d-flex flex-column gap-2">
          <div class="d-flex flex-column flex-md-row gap-2">
            <div class="d-flex flex-row gap-2 w-100">
              <div v-if="!form.ConAutorizaciones || (estados == null || estados.length == 0)" class="position-relative">
                <!-- Ícono para abrir el menú de ordenación -->
                <i class="bi bi-filter fs-1 text-goethe-accent-claro fs-4" @click="showMenuFilter = !showMenuFilter" style="cursor: pointer;"></i>

                <!-- Fondo transparente para detectar clics fuera -->
                <div v-if="showMenuFilter" class="overlay" @click="showMenuFilter = false"></div>

                <div v-if="showMenuFilter" class="dropdown-menu show position-absolute bg-goethe-accent-claro-2 border-0 user-select-none px-2" aria-labelledby="dropdownMenuButton" style="top: 100%; left: 0; z-index: 1000; min-width: 180px;">
                  <p class="m-0 fs-6 texto-principal">Ordenar por:</p>
                  <div class="form-check d-flex align-items-center gap-1 texto-principal" style="cursor: pointer;">
                    <input class="form-check-input" type="radio" id="sortTitulo" v-model="sortKey" value="Nombre" style="transform: scale(0.8);" @change="getSubmits(form, currentPage)">
                    <label class="form-check-label" for="sortTitulo">Nombre</label>
                  </div>
                  <div class="form-check d-flex align-items-center gap-1" style="cursor: pointer;">
                    <input class="form-check-input" type="radio" id="sortUltMod" v-model="sortKey" value="FechaDesc" style="transform: scale(0.8);" @change="getSubmits(form, currentPage)">
                    <label class="form-check-label" for="sortUltMod">Fecha Desc</label>
                  </div>
                  <div class="form-check d-flex align-items-center gap-1" style="cursor: pointer;">
                    <input class="form-check-input" type="radio" id="sortCreadoPor" v-model="sortKey" value="FechaAsc" style="transform: scale(0.8);" @change="getSubmits(form, currentPage)">
                    <label class="form-check-label" for="sortCreadoPor">Fecha Asc</label>
                  </div>
                </div>
              </div>
              <div class="d-flex align-items-center position-relative w-100">
                <!-- Ícono SVG de lupa -->
                <svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true" class="position-absolute top-50 start-0 translate-middle-y ms-2 texto-principal" style="pointer-events: none">
                  <path d="M14.386 14.386l4.0877 4.0877-4.0877-4.0877c-2.9418 2.9419-7.7115 2.9419-10.6533 0-2.9419-2.9418-2.9419-7.7115 0-10.6533 2.9418-2.9419 7.7115-2.9419 10.6533 0 2.9419 2.9418 2.9419 7.7115 0 10.6533z" stroke="currentColor"  fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <input type="text" class="form-control texto-principal m-0 rounded-3 border-0 fondo-terciario sombra-sm" :placeholder="$t('buscar') + '...'" v-model="search"
                  style="padding-left: 35px;" @keyup.enter="getSubmits(form, currentPage)" @input="filterSubmits"/>

                <button v-if="search" type="button" class="position-absolute top-50 end-0 translate-middle-y border-0 bg-transparent" @click="search = ''; getSubmits(form, currentPage)">
                  <i class="bi bi-x texto-principal" style="font-size: 30px;"></i> <!-- Icono de "x" -->
                </button>
              </div>
            </div>
            
            <div class="d-flex gap-2 align-items-center">
              <input type="date" class="form-control texto-principal rounded-3 border-0 fondo-terciario sombra-sm" v-model="fechaDesde" @onchange="getSubmits(form, currentPage)"/>
              <span class="texto-principal">a</span>
              <input type="date" class="form-control texto-principal rounded-3 border-0 fondo-terciario sombra-sm" v-model="fechaHasta" @onchange="getSubmits(form, currentPage)"/>
            </div>
          </div>
          <div v-if="form.ConAutorizaciones && (estados != null && estados.length > 0)" class="d-flex flex-row gap-2">
            <div class="position-relative">
              <!-- Ícono para abrir el menú de ordenación -->
              <i class="bi bi-filter fs-1 text-goethe-accent-claro fs-4" @click="showMenuFilter = !showMenuFilter" style="cursor: pointer;"></i>

              <!-- Fondo transparente para detectar clics fuera -->
              <div v-if="showMenuFilter" class="overlay" @click="showMenuFilter = false"></div>

              <div v-if="showMenuFilter" class="dropdown-menu show position-absolute bg-goethe-accent-claro-2 border-0 user-select-none px-2" aria-labelledby="dropdownMenuButton" style="top: 100%; left: 0; z-index: 1000; min-width: 180px;">
                <p class="m-0 fs-6 texto-principal">Ordenar por:</p>
                <div class="form-check d-flex align-items-center gap-1 texto-principal" style="cursor: pointer;">
                  <input class="form-check-input" type="radio" id="sortTitulo" v-model="sortKey" value="Nombre" style="transform: scale(0.8);" @change="getSubmits(form, currentPage)">
                  <label class="form-check-label" for="sortTitulo">Nombre</label>
                </div>
                <div class="form-check d-flex align-items-center gap-1 texto-principal" style="cursor: pointer;">
                  <input class="form-check-input" type="radio" id="sortUltMod" v-model="sortKey" value="FechaDesc" style="transform: scale(0.8);" @change="getSubmits(form, currentPage)">
                  <label class="form-check-label" for="sortUltMod">Fecha Desc</label>
                </div>
                <div class="form-check d-flex align-items-center gap-1 texto-principal" style="cursor: pointer;">
                  <input class="form-check-input" type="radio" id="sortCreadoPor" v-model="sortKey" value="FechaAsc" style="transform: scale(0.8);" @change="getSubmits(form, currentPage)"/>
                  <label class="form-check-label" for="sortCreadoPor">Fecha Asc</label>
                </div>
              </div>
            </div>
            <div class="d-flex flex-wrap gap-2 align-items-center" v-if="form.ConAutorizaciones">
              <p class="m-0 fw-bold">{{ $t('filtros') }}:</p>
              <div v-for="estado in estados" :key="estado.IdAutorizacionEstado"
                class="form-check-pill"
                :class="{ 'checked': estadoVisible === estado.EstadoNombre }"
                @click="estadoVisible = estadoVisible === estado.EstadoNombre ? '' : estado.EstadoNombre; getSubmits(form, currentPage)">
                <span>{{ $t(estado.EstadoNombre) }}</span>
              </div>
              <div
                class="form-check-pill"
                :class="{ 'checked': estadoVisible === 'Pendiente' }"
                @click="estadoVisible = estadoVisible === 'Pendiente' ? '' : 'Pendiente'; getSubmits(form, currentPage)">
                <span>{{ $t('Pendiente') }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- Submits -->
        <div v-for="(submit, index) in filteredSubmits.filter(s => s.Valores[0].IdRespuesta === null)" :key="submit.IdSubmit" class="d-flex flex-column gap-2 w-100 border-0 sombra-sm fondo-secundario rounded-3">
          <!-- Mostrar el nombre del evaluador o 'submit' si no existe -->
          <div class="d-flex flex-row gap-2 w-100 px-3 border border-0 fondo-terciario sombra-sm rounded-3 justify-content-between align-items-center" style="min-height: 60px; cursor: pointer;" @click="submit.showValues = !submit.showValues">
            <div class="d-flex gap-2 align-items-center">
              <div class="d-flex align-items-center justify-content-center p-0">
                <img v-if="submit?.IdEvaluadorNavigation?.FotoUrl" :src="submit?.IdEvaluadorNavigation?.FotoUrl" alt="Profile Picture" class="img-responsive" style="width: 40px; height: 40px; border-radius: 50%; object-fit: cover; padding: 2px;" />
                <div v-if="!submit?.IdEvaluadorNavigation?.FotoUrl" alt="Profile Picture" class="d-flex align-items-center justify-content-center img-responsive pb-1" style="width: 40px; height: 40px; border-radius: 50%; background-color: #bbbbbb; object-fit: cover; padding: 2px;" >
                  <svg width="20" height="20" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Dribbble-Light-Preview" transform="translate(-140.000000, -2159.000000)" fill="#ffffff"><g id="icons" transform="translate(56.000000, 160.000000)"><path d="M100.562548,2016.99998 L87.4381713,2016.99998 C86.7317804,2016.99998 86.2101535,2016.30298 86.4765813,2015.66198 C87.7127655,2012.69798 90.6169306,2010.99998 93.9998492,2010.99998 C97.3837885,2010.99998 100.287954,2012.69798 101.524138,2015.66198 C101.790566,2016.30298 101.268939,2016.99998 100.562548,2016.99998 M89.9166645,2004.99998 C89.9166645,2002.79398 91.7489936,2000.99998 93.9998492,2000.99998 C96.2517256,2000.99998 98.0830339,2002.79398 98.0830339,2004.99998 C98.0830339,2007.20598 96.2517256,2008.99998 93.9998492,2008.99998 C91.7489936,2008.99998 89.9166645,2007.20598 89.9166645,2004.99998 M103.955674,2016.63598 C103.213556,2013.27698 100.892265,2010.79798 97.837022,2009.67298 C99.4560048,2008.39598 100.400241,2006.33098 100.053171,2004.06998 C99.6509769,2001.44698 97.4235996,1999.34798 94.7348224,1999.04198 C91.0232075,1998.61898 87.8750721,2001.44898 87.8750721,2004.99998 C87.8750721,2006.88998 88.7692896,2008.57398 90.1636971,2009.67298 C87.1074334,2010.79798 84.7871636,2013.27698 84.044024,2016.63598 C83.7745338,2017.85698 84.7789973,2018.99998 86.0539717,2018.99998 L101.945727,2018.99998 C103.221722,2018.99998 104.226185,2017.85698 103.955674,2016.63598" id="profile_round-[#1342]"></path></g></g></svg>
                </div>
              </div>
              <div class="d-flex flex-column align-items-left">
                <span class="d-none d-sm-block">{{ submit?.IdEvaluadorNavigation && !form.Anonimo ?
                (submit?.IdEvaluadorNavigation?.Apellido + " " + submit?.IdEvaluadorNavigation?.Nombre) :
                "Submit " + (index + 1) }}</span>
                <span class="d-block d-sm-none">{{ submit?.IdEvaluadorNavigation && !form.Anonimo ?
                (submit?.IdEvaluadorNavigation?.Apellido + " " + submit?.IdEvaluadorNavigation?.Nombre).substring(0, 12) + '...' :
                "Submit " + (index + 1) }}</span>
                <span class="fs-7 d-flex align-items-center gap-1"> 
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 7V12L13.5 14.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" class="stroke-secundario" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <span class="d-sm-none texto-secundario">
                    {{ new Date(new Date(submit.FechaHora).setHours(new Date(submit.FechaHora).getHours() - 3)).toLocaleDateString('es-ES', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false, // Para usar el formato de 24 horas
                  }).slice(0, 10) }}
                  </span>
                  <span class="d-none d-sm-inline texto-secundario">
                    {{ new Date(new Date(submit.FechaHora).setHours(new Date(submit.FechaHora).getHours() - 3)).toLocaleDateString('es-ES', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false, // Para usar el formato de 24 horas
                  }) }}
                  </span>
                </span>
              </div>
              <router-link :to="'/formularios/completar?idForm='+idForm+'&idSubmit='+submit.IdSubmit" v-if="form.ConEdicionDeCompletado && (form.AQuienEdita === 'Todos' || (form.AQuienEdita === 'Las Propias' && submit.IdEvaluador === user.idPersona))"
                class="btn p-2 d-none d-md-flex flex-row align-items-center justify-content-center tooltip-container border-0">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-principal">
                  <path d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M21 21H12" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span class="tooltip-text">{{ $t('editar') }}</span>
              </router-link>
              <router-link v-if="form.ConRespuesta" :to="'/formularios/responder?idForm=' + idForm + '&idSubmit=' + submit.IdSubmit" class="btn p-2 d-flex flex-row align-items-center justify-content-center tooltip-container rounded-4 p-2">
                <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 9H17M7 13H12M21 20L17.6757 18.3378C17.4237 18.2118 17.2977 18.1488 17.1656 18.1044C17.0484 18.065 16.9277 18.0365 16.8052 18.0193C16.6672 18 16.5263 18 16.2446 18H6.2C5.07989 18 4.51984 18 4.09202 17.782C3.71569 17.5903 3.40973 17.2843 3.21799 16.908C3 16.4802 3 15.9201 3 14.8V7.2C3 6.07989 3 5.51984 3.21799 5.09202C3.40973 4.71569 3.71569 4.40973 4.09202 4.21799C4.51984 4 5.0799 4 6.2 4H17.8C18.9201 4 19.4802 4 19.908 4.21799C20.2843 4.40973 20.5903 4.71569 20.782 5.09202C21 5.51984 21 6.0799 21 7.2V20Z" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span class="tooltip-text">{{ $t('responder') }}</span>
              </router-link>
              <button v-if="hasAdminForms" class="btn p-2 d-none d-md-flex flex-row align-items-center justify-content-center tooltip-container border-0" @click.stop="deleteSubmit(submit.IdSubmit)">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-principal">
                  <path d="M10 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M14 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M4 7H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span class="tooltip-text">{{ $t('eliminar') }}</span>
              </button>
            </div>

            <div class="d-flex flex-row gap-3 align-items-center">
              <div v-if="form.ConAutorizaciones && !form.OcultarHistorialAutorizaciones" class="d-flex-wrap d-sm-flex flex-row p-1 w-100">
                <div v-for="(nivel, nroOrden) in form.AutorizadoresNivel" :key="nroOrden" class="d-inline-flex align-items-center justify-content-center ms-2 gap-2">
                  <div class="d-flex gap-1" style="position: relative;">
                    <router-link :to="'/formularios/autorizar?idForm=' + idForm + '&idSubmit='+submit.IdSubmit + '&idNivel=' + nivel.IdAutorizadoresNivel"
                      v-if="nombreAutorizadorGrupo(nivel, submit).EsDelUsuario" class="rounded-2 d-inline-flex flex-row align-items-center justify-content-center p-1 text-decoration-none sombra-sm"
                      :class="{ 'select-aprobado': autorizacionNivel(nivel, submit).estado === true,
                                'select-desaprobado': autorizacionNivel(nivel, submit).estado === false,
                                'select-nada': autorizacionNivel(nivel, submit).estado === null}" style="height: 22px;"
                      @contextmenu.prevent="mostrarMenu($event, submit, nroOrden, true)"
                    >
                      <svg v-if="autorizacionNivel(nivel, submit).estado === true" width="14" height="14" viewBox="0 1 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path class="fill-principal" fill-rule="evenodd" clip-rule="evenodd" d="M20.6097 5.20743C21.0475 5.54416 21.1294 6.17201 20.7926 6.60976L10.7926 19.6098C10.6172 19.8378 10.352 19.9793 10.0648 19.9979C9.77765 20.0166 9.49637 19.9106 9.29289 19.7072L4.29289 14.7072C3.90237 14.3166 3.90237 13.6835 4.29289 13.2929C4.68342 12.9024 5.31658 12.9024 5.70711 13.2929L9.90178 17.4876L19.2074 5.39034C19.5441 4.95258 20.172 4.87069 20.6097 5.20743Z"/>
                      </svg>
                      <svg v-else-if="autorizacionNivel(nivel, submit).estado === false" class="mx-1 fill-principal" height="10" width="10" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                        viewBox="0 0 47.095 47.095" xml:space="preserve">
                        <path d="M45.363,36.234l-13.158-13.16l12.21-12.21c2.31-2.307,2.31-6.049,0-8.358c-2.308-2.308-6.05-2.307-8.356,0l-12.212,12.21
                          L11.038,1.906c-2.309-2.308-6.051-2.308-8.358,0c-2.307,2.309-2.307,6.049,0,8.358l12.81,12.81L1.732,36.831
                          c-2.309,2.31-2.309,6.05,0,8.359c2.308,2.307,6.049,2.307,8.356,0l13.759-13.758l13.16,13.16c2.308,2.308,6.049,2.308,8.356,0
                          C47.673,42.282,47.672,38.54,45.363,36.234z"/>
                      </svg>
                      <svg v-if="autorizacionNivel(nivel, submit).estado === null" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 7V12L13.5 14.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <span class="fs-7 texto-principal" style="margin-right: 2px;">{{ $t(autorizacionNivel(nivel, submit).nombre) }}</span>
                    </router-link>
                    <div v-if="!nombreAutorizadorGrupo(nivel, submit).EsDelUsuario" class="tooltip-container rounded-2 d-inline-flex flex-row align-items-center justify-content-center p-1 text-decoration-none sombra-sm"
                      :class="{ 'select-aprobado': autorizacionNivel(nivel, submit).estado === true,
                                'select-desaprobado': autorizacionNivel(nivel, submit).estado === false,
                                'select-nada': autorizacionNivel(nivel, submit).estado === null}" style="height: 22px;"
                      @contextmenu.prevent="mostrarMenu($event, submit, nroOrden, nombreAutorizadorGrupo(nivel, submit).EsGeneral)"
                    >
                      <svg v-if="autorizacionNivel(nivel, submit).estado === true" width="14" height="14" viewBox="0 1 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path class="fill-principal" fill-rule="evenodd" clip-rule="evenodd" d="M20.6097 5.20743C21.0475 5.54416 21.1294 6.17201 20.7926 6.60976L10.7926 19.6098C10.6172 19.8378 10.352 19.9793 10.0648 19.9979C9.77765 20.0166 9.49637 19.9106 9.29289 19.7072L4.29289 14.7072C3.90237 14.3166 3.90237 13.6835 4.29289 13.2929C4.68342 12.9024 5.31658 12.9024 5.70711 13.2929L9.90178 17.4876L19.2074 5.39034C19.5441 4.95258 20.172 4.87069 20.6097 5.20743Z"/>
                      </svg>
                      <svg v-else-if="autorizacionNivel(nivel, submit).estado === false" class="mx-1 fill-principal" height="10" width="10" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                        viewBox="0 0 47.095 47.095" xml:space="preserve">
                        <path d="M45.363,36.234l-13.158-13.16l12.21-12.21c2.31-2.307,2.31-6.049,0-8.358c-2.308-2.308-6.05-2.307-8.356,0l-12.212,12.21
                          L11.038,1.906c-2.309-2.308-6.051-2.308-8.358,0c-2.307,2.309-2.307,6.049,0,8.358l12.81,12.81L1.732,36.831
                          c-2.309,2.31-2.309,6.05,0,8.359c2.308,2.307,6.049,2.307,8.356,0l13.759-13.758l13.16,13.16c2.308,2.308,6.049,2.308,8.356,0
                          C47.673,42.282,47.672,38.54,45.363,36.234z"/>
                      </svg>
                      <svg v-if="autorizacionNivel(nivel, submit).estado === null" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 7V12L13.5 14.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <span class="tooltip-text">{{ $t(autorizacionNivel(nivel, submit).nombre) }}</span>
                    </div>
                    <!-- Menú contextual personalizado -->
                    <div
                      v-if="submit.niveles[nroOrden].menuVisible"
                      :style="{ position: 'absolute', top: 0 + 'px', left: -10 + 'px', transform: 'translateY(-100%)'}"
                      class="custom-context-menu fondo-secundario rounded-4 sombra-sm"
                    >
                      <ul v-if="!nombreAutorizadorGrupo(nivel, submit).DebeAutorizarAnterior" class="list-unstyled mb-0 p-2 d-flex flex-column gap-2">
                        <li v-for="(estado) in nivel.Estados.filter(e => e.IdAutorizacionEstado != autorizacionNivel(nivel, submit).idEstado)" :key="estado.IdAutorizacionEstado" @click.stop="submitAutorizacion(estado, submit, nivel)"
                        class="rounded-2 d-inline-flex flex-row align-items-center justify-content-center p-1 px-2 sombra-sm"
                        :class="{ 'select-aprobado': estado.Autorizado === true,
                                'select-desaprobado': estado.Autorizado === false,
                                'select-nada': estado.Autorizado === null}">
                          {{ estado.EstadoNombre }}
                        </li>
                      </ul>
                      <div v-if="nombreAutorizadorGrupo(nivel, submit).DebeAutorizarAnterior" class="p-2">
                        <p class="m-0 rounded-2 d-inline-flex p-1 px-2 select-desaprobado sombra-sm">{{ $t('faltanAutorizacionesPrevias') }}</p>
                      </div>
                    </div>

                    <!-- Div invisible que cubre todo el contenido y detecta el clic fuera -->
                    <div v-if="submit.niveles[nroOrden].menuVisible"
                        class="overlay-2"
                        @click.stop="submit.niveles[nroOrden].menuVisible = false"
                        @contextmenu.prevent="submit.niveles[nroOrden].menuVisible = false"
                    ></div>

                    <div v-if="submit.niveles[nroOrden].loadingAutorizacion" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
                      <img src="@/assets/LOADING.gif" style="width: 10px;" alt="Cargando..." />
                    </div>
                  </div>
                </div>
              </div>
              <svg width="22px" height="22px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :style="{ transform: submit.showValues ? 'scaleY(1)' : 'scaleY(-1)' }">
                <path d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z" class="fill-principal"/>
              </svg>
            </div>
          </div>


          <!-- Mostrar los valores solo si showValues es true -->
          <div v-show="submit.showValues">
            <div v-if="form.ConAutorizaciones && !form.OcultarHistorialAutorizaciones" class="d-flex flex-row p-1">
              <div v-for="(nivel, nroOrden) in form.AutorizadoresNivel" :key="nroOrden" class="d-flex align-items-center justify-content-center ms-2 gap-2">
                <div class="tooltip-container">
                  <div class="rounded-3 d-inline-flex flex-column align-items-center justify-content-center p-1 px-2"
                    :class="{ 'select-aprobado-2': autorizacionNivel(nivel, submit).estado === true,
                              'select-desaprobado-2': autorizacionNivel(nivel, submit).estado === false,
                              'select-nada-2': autorizacionNivel(nivel, submit).estado === null}" style="height: 65px;"
                  >
                    <span>{{ $t(autorizacionNivel(nivel, submit).nombre) }}</span>
                    <span v-if="nombreAutorizadorGrupo(nivel, submit)?.Nombre" class="fs-8 fw-normal">{{ nombreAutorizadorGrupo(nivel, submit)?.Nombre }}</span>
                    <span v-else class="fs-8 fw-normal">XX xx</span>
                    <span v-if="nombreAutorizadorGrupo(nivel, submit)?.FechaHora" class="fs-8 fw-normal texto-secundario">{{ nombreAutorizadorGrupo(nivel, submit)?.FechaHora }}</span>
                  </div>
                  <span class="tooltip-text-right fondo-secundario border-0" style="width: 300px; max-width: 80vw;">{{ autorizacionNivel(nivel, submit)?.comentario }}</span>
                </div>
                <div
                  v-if="parseInt(nroOrden) < Object.keys(form.AutorizadoresNivel).length-1"
                  class="d-inline-block texto-principal mb-1 fs-4"
                >
                  →
                </div>
              </div>
            </div>

            <div v-if="form.ConAutorizaciones && !form.OcultarHistorialAutorizaciones" class="d-flex flex-column p-1 gap-2">
              <div v-for="(nivel, nroOrden) in form.AutorizadoresNivel" :key="nroOrden" class="d-flex flex-column justify-content-center ms-2">
                <div v-if="autorizacionNivel(nivel, submit).comentario" class="d-flex flex-column justify-content-center">
                  <span>{{ $t('comentario') }}: <span class="fw-bold">{{ autorizacionNivel(nivel, submit)?.comentario }}</span></span>
                  <span v-if="nombreAutorizadorGrupo(nivel, submit)?.Nombre" class="fs-8 fw-normal ms-2">{{ $t('por') }}: {{ nombreAutorizadorGrupo(nivel, submit)?.Nombre }}</span>
                  <span v-else class="fs-8 fw-normal ms-2">{{ $t('por') }}: XX xx</span>
                </div>
              </div>
            </div>

            
            <!-- Mostrar los valores agrupados -->
            <div v-if="submit.IdEvaluadoNavigation" class="d-flex flex-column gap-2 p-2 px-3">
              <div class="d-flex flex-row justify-content-between w-100">
                <span class="fs-7 m-0"><strong>Evaluado:</strong> &nbsp;{{ (submit.IdEvaluadoNavigation?.Apellido + " " + submit.IdEvaluadoNavigation?.Nombre) }}</span>
              </div>
            </div>
            <div v-for="(valor, indexValue) in submit.Valores" :key="valor.IdSubmit" class="d-flex flex-column gap-1 p-2 px-3">
              <!-- Mostrar los valores agrupados -->
              <div class="d-flex flex-column">
                <div class="d-flex flex-column justify-content-center w-100">
                  <span v-if="!valor.ValorObservado.includes('https')" class="fs-6 m-0"> <strong>{{(indexValue+1)+ ". "}}</strong>  {{valor.observacion.NombreObservacion }}: &nbsp;<strong>{{ valor.ValorObservado }}</strong></span>
                  <span v-if="valor.ValorObservado.includes('https')" class="fs-6 m-0"><strong>{{ (indexValue+1) }}. Archivo:</strong> &nbsp;<a :href="valor.ValorObservado" target="_blank">{{ valor.Comentario }}</a></span>
                  <span class="fs-7 d-flex align-items-center m-0 texto-terciario" style="min-width: 160px;">
                    {{ new Date(new Date(submit.FechaHora).setHours(new Date(submit.FechaHora).getHours() - 3)).toLocaleString('es-AR', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                      hour: '2-digit',
                      minute: '2-digit',
                      second: '2-digit',
                      hourCycle: 'h23'
                    }) }}
                  </span>
                </div>
                <div v-if="valor.Comentario && !valor.ValorObservado.includes('https')" class="d-flex flex-row justify-content-start w-100">
                  <span class="fs-6 d-flex align-items-center m-0 ms-3">Comentario: &nbsp;<strong>{{ valor.Comentario }}</strong></span>
                </div>
              </div>

              <div v-if="valor.Respuestas && !form.Anonimo" class="d-flex flex-column gap-2">
                <div v-for="(respuesta, indexRespuesta) in valor.Respuestas" :key="respuesta.IdSubmit" class="d-flex flex-column w-100">
                  <!-- Divider -->
                  <div v-if="indexRespuesta!=0" class="col-12 mb-2" style="border-top: 1px solid #ccc; height: 1px"></div>
                  <div class="d-flex flex-row gap-2 w-100">
                    <svg class="fill-principal" width="20" height="20" viewBox="0 0 256 256" id="Flat" xmlns="http://www.w3.org/2000/svg" style="transform: scaleX(-1);">
                      <path d="M232,56A104.11791,104.11791,0,0,1,128,160H51.31372l34.34351,34.34277a8.00053,8.00053,0,0,1-11.31446,11.31446l-48-48c-.05639-.05664-.10424-.11768-.15869-.17578-.12524-.13282-.25122-.26514-.36719-.40625-.09106-.11084-.17114-.22706-.25537-.3418-.07055-.09522-.14477-.188-.21093-.28662-.085-.12647-.15894-.25782-.23584-.38819-.05567-.09423-.11524-.186-.16724-.2832-.06909-.12891-.12817-.26172-.1897-.39355-.04931-.10547-.102-.209-.147-.31641-.05225-.12695-.095-.25586-.14063-.38477-.042-.11816-.08764-.23437-.12426-.355-.03907-.1289-.06787-.25976-.10034-.39013-.03052-.12305-.06519-.24414-.09009-.36914-.03-.15186-.04859-.30469-.06983-.45752-.01465-.106-.03515-.20948-.04565-.3169a8.02276,8.02276,0,0,1,0-1.584c.0105-.10742.031-.21094.04565-.3169.02124-.15283.0398-.30566.06983-.45752.0249-.125.05957-.24609.09009-.36914.03247-.13037.06127-.26123.10034-.39013.03662-.12061.08227-.23682.12426-.355.04566-.12891.08838-.25782.14063-.38477.04492-.10742.09766-.21094.147-.31641.06153-.13183.12061-.26464.1897-.39355.052-.09717.11157-.189.16724-.2832.0769-.13037.15087-.26172.23584-.38819.06616-.09863.14038-.1914.21093-.28662.08423-.11474.16431-.231.25537-.3418.116-.14111.24195-.27343.36719-.40625.05445-.0581.1023-.11914.15869-.17578l48-48a8.00053,8.00053,0,0,1,11.31446,11.31446L51.31372,144H128a88.09957,88.09957,0,0,0,88-88,8,8,0,0,1,16,0Z"/>
                    </svg>
                    <div class="d-flex flex-column justify-content-center w-100">
                      <span class="fs-7 m-0"><strong>{{ $t('respuestaDe') }}&nbsp;{{ respuesta.Submit?.IdEvaluadorNavigation?.Apellido + " " + respuesta.Submit?.IdEvaluadorNavigation?.Nombre }}:</strong>&nbsp;{{ respuesta.ValorObservado }}</span>
                      <p class="fs-7 d-flex align-items-center m-0 texto-terciario" style="min-width: 160px;">{{ respuesta.FechaHora }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Controles de Paginación --> 
        <nav aria-label="Page navigation" v-if="totalPages>1">
          <ul class="pagination m-0">
            <li class="p-2 rounded-start bg-goethe-accent-claro-3 borde-secundario border-1 border-end sombra" :class="{ disabled: currentPage === 1 }">
              <a class="p-2 text-dark text-decoration-none" href="#" @click.prevent="prevPage()">{{ $t('anterior') }}</a>
            </li>
            <li class="p-2 bg-goethe-accent-claro-3 borde-secundario sombra">
              <a class="p-2 text-dark text-decoration-none" href="#" @click.prevent="">{{ currentPage }} {{$t('de')}} {{ totalPages }}</a>
            </li>
            <li class="p-2 rounded-end bg-goethe-accent-claro-3 borde-secundario border-1 border-start sombra" :class="{ disabled: currentPage === totalPages }">
              <a class="p-2 text-dark text-decoration-none" href="#" @click.prevent="nextPage()">{{ $t('siguiente') }}</a>
            </li>
          </ul>
        </nav>
      </div>

      <div v-if="loading" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
        <img src="@/assets/LOADING.gif" style="width: 80px;" alt="Cargando..." />
      </div>
    </div>
    <div v-if="errorForm" class="d-flex flex-column flex-sm-row align-items-center justify-content-center gap-2" style="height: 100vh;">
      <div class="order-1 order-sm-2">
        <p class="m-0 fs-1 fw-bold">Oops...</p>
        <p class="m-0 fs-4">{{ $t('noEncontramosForm') }}</p>
      </div>
      <img src="../../assets/errorGoethe.png" alt="ErrorGoethe" class="img-responsive order-2 order-sm-1" style="width: 40vw;max-width: 400px; height: auto;" />
    </div>
  </div>
</template>

<script>
  import { ref, computed, onMounted, onBeforeUnmount, nextTick  } from 'vue';
  import { API_BASE_URL } from '../../config';
  import {useStore} from "vuex";
  import {useRouter} from "vue-router";
  import Chart from 'chart.js/auto';
  import { useI18n } from 'vue-i18n';
  import * as signalR from '@microsoft/signalr';
  import api from '@/services/api';

export default {
  setup() {
    const { t } = useI18n();
    const router = useRouter();
    const store = useStore();
    const user = computed(() => store.state.user);
    const form = ref({
      Descripcion: '',
      ConEleccionEvaluado: false,
      TipoEvaluado: '',
      ConEleccionMateria: false,
      NivelMateria: '',
      FechaCreacion: new Date(new Date().getTime() - 3 * 60 * 60 * 1000),
      FechaModificacion: new Date(new Date().getTime() - 3 * 60 * 60 * 1000),
      IdCreador: null,
      IdFormulario: null,
      idModificadoPor: null,
      idModificadoPorNavigation: { nombre: '', apellido: ''},
      NombreFormulario: '',
      ConAccesoRestringido: false,
      ConEdicionDeCompletado: false,
      ConVisualizacionRestringida: false,
      AccesoFormularios: [], // Array de objetos para observaciones
      Observacions: [], // Array de objetos para observaciones
    });
    const accesoFormulario = ref({
      IdFormulario: "",
      IdPersona: "",
      TipoPermiso: "",
      FechaHora: null,
    })
    const charts = ref([]);
    const userPermission = ref('');

    const persona = ref([]);
    const grupos = ref([]);
    const searchQuery = ref(''); // Estado para la búsqueda
    const filteredPersonas = ref([]); // Personas filtradas
    const filteredLista = ref([]); // Personas filtradas
    const selectedPersona = ref(null); // Persona seleccionada
    const selectedLista = ref(null);
    const tipoPermiso = ref('Lector');
    const errorForm = ref(false);
    const loading = ref(false);
    const loadingSubmitAcceso = ref(false);
    const loadingListas = ref(false);
    const errorMessage = ref('');
    const tipoAcceso = ref('persona');

    let asignaturas = ref([]);
    let submits = ref([]);

    const idForm = localStorage.getItem('idForm');
    const conEnvio = ref(true);
    const isFirstDivVisible = ref(true);
    const showDeleteMenu = ref(false);
    const showAccessMenu = ref(false);
    const showShareMenu = ref(null);
    const showMenuFilter = ref(false);
    const sortKey = ref('');
    const urlCompartir = ref('');
    const urlCompartirResponder = ref('');
    const search = ref('');
    let estadoVisible = ref('');
    const fechaDesde = ref(null);
    const fechaHasta = ref(null);
    let estados = ref([]);
    let connection;
    const gruposDisponibles = ref([]);
    const currentPage = ref(1);
    const totalPages = ref(1);
    let timeoutId = null;

    const hasAdminForms = ref(false);

    const checkAuth = async  () => {
      if (user.value && user.value.personasPermisos) {
        var permisoAComprobar = 'VerFormularios'
        if (user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) ||
          user.value.personasRoles.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar))||
          user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation.permiso === 'VerTodosForms') ||
          user.value.personasRoles.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === 'VerTodosForms'))){
          console.log("Tiene Permiso")
        }
        else{
          console.log('Usuario no tiene permiso a acceder.');
          await router.push('/');
        }
        
        permisoAComprobar = 'AdminForms'
        if (user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
          user.value.personasRoles.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar))){
          hasAdminForms.value = true;
        }
      }
    };

    const nextPage = () => {
      getSubmits(form.value, currentPage.value + 1)
      currentPage.value += 1
    };

    const prevPage = () => {
      if (currentPage.value > 1) {
        getSubmits(form.value, currentPage.value - 1)
        currentPage.value -= 1
      }
    };

    const addRedirectUrl = async () => {
      const url = window.location.href;
      const cleanedUrl = url.split("/#")[1];
      if(cleanedUrl!="/login"){
        localStorage.setItem('redirectAfterLogin', cleanedUrl);
      }
    }

    const habilitarFormulario = async () => {
      try {
        
        const response = await api.put(`api/Formularios/Habilitar`,
          {}, // body vacío
          {
            params: { 
              idForm: form.value.IdFormulario,
              habilitado: !form.value.Habilitado
            },
          }
        );

        if (response.status === 202 || response.status === 200) {
          console.log('Formulario habilitado con éxito');
          fetchForm(); // actualiza la lista
        } else {
          console.warn('No se pudo habilitar el formulario:', response.status);
        }
      } catch (error) {
        console.error('Error al habilitar el formulario:', error);
      }
    }

    const filteredSubmits = computed(() => {
      const result = submits.value
      
      return result;
    });

    const filterSubmits = () => {
      // Limpia el temporizador anterior si existe
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      // Establece un nuevo temporizador
      timeoutId = setTimeout(() => {
        // Llama a fetchUsers después de 500ms (0.5 segundos) de inactividad
        getSubmits(form.value, currentPage.value);
      }, 1000); // Puedes ajustar este valor a tu gusto (en milisegundos)
    };

    const autorizacionNivel = (nivel, submit) => {
      let autorizacionesDelGrupo = [];

      for (const aut of nivel.Estados) {
        const match = submit.Autorizacion?.filter(a => a.IdAutorizacionEstado === aut.IdAutorizacionEstado)
          .sort((a, b) => new Date(b.FechaHora) - new Date(a.FechaHora))[0];
        if(match!=null){
          autorizacionesDelGrupo.push(match);
        }
      }

      // Ordenar por FechaHora descendente (más reciente primero)
      autorizacionesDelGrupo.sort((a, b) => new Date(b.FechaHora) - new Date(a.FechaHora));

      const match = autorizacionesDelGrupo[0]; // la más reciente de todas las del grupo
      if (match?.AutorizacionEstado?.EstadoNombre !== null && match?.AutorizacionEstado?.EstadoNombre !== undefined) {
        return {nombre: match.AutorizacionEstado.EstadoNombre, comentario: match.Comentario, estado: match.AutorizacionEstado.Autorizado, idEstado: match.AutorizacionEstado.IdAutorizacionEstado};
      }
      return {nombre: 'Pendiente', comentario: '', estado: null, idEstado: null}; // Ninguno respondió aún
    };

    const nombreAutorizadorGrupo = (nivel, submit) => {
      let autorizacionesDelGrupo = [];

      let esDelUsuario = false;
      let esGeneral = false;
      for (const nivel of form.value.AutorizadoresNivel) {
        for (const aut of nivel.Autorizadores) {
          if(aut.IdPersona == user.value?.idPersona && aut.AutorizadorGeneral){
            esGeneral = true;
          }
        }
      }
      for (const aut of nivel.Autorizadores) {
        const match = submit.Autorizacion
          .filter(a => a.IdAutorizadores === aut.IdAutorizadores)
          .sort((a, b) => new Date(b.FechaHora) - new Date(a.FechaHora))[0];
        if(match!=null){
          autorizacionesDelGrupo.push(match);
        }
        if ((aut.IdPersona == user.value?.idPersona && aut.Inhabilitado != true && chequearPermisosAutorizaciones(nivel, submit.IdEvaluador))||(aut.IdPersona == user.value?.idPersona && nivel.SePuedenAutoAutorizar && aut.Inhabilitado != true)) {
          esDelUsuario = true;
        }
      }

      // Ordenar por FechaHora descendente (más reciente primero)
      autorizacionesDelGrupo.sort((a, b) => new Date(b.FechaHora) - new Date(a.FechaHora));

      const match2 = autorizacionesDelGrupo[0]; // la más reciente de todas las del grupo


      let autorizacionesDelGrupo2 = [];

      //Nivel Anterior
      let nivelAnterior = form.value.AutorizadoresNivel.find( an => an.NroOrden == (nivel.NroOrden - 1) )
      let debeAutorizarAnterior = false;
      if(nivelAnterior){
        for (const est of nivelAnterior.Estados) {
          const match3 = submit.Autorizacion
            .filter(a => a.IdAutorizacionEstado === est.IdAutorizacionEstado)
            .sort((a, b) => new Date(b.FechaHora) - new Date(a.FechaHora))[0];
          if(match3!=null){
            autorizacionesDelGrupo2.push(match3);
          }
        }

        // Ordenar por FechaHora descendente (más reciente primero)
        autorizacionesDelGrupo2.sort((a, b) => new Date(b.FechaHora) - new Date(a.FechaHora));
        
        autorizacionesDelGrupo2 = autorizacionesDelGrupo2.filter(a => a && a.AutorizacionEstado).filter(a => a.AutorizacionEstado.Autorizado === true);
        let match4 = null;
        match4 = autorizacionesDelGrupo2[0]; // la más reciente de todas las del grupo
        if(match4==null){
          debeAutorizarAnterior = true;
        }
      }
      if(form.value.AutorizarDesordenado){
        debeAutorizarAnterior = false;
      }


      if (match2?.AutorizacionEstado?.EstadoNombre) {
        let fechaHora = new Date(new Date(match2.FechaHora).setHours(new Date(match2.FechaHora).getHours() - 3)).toLocaleString('es-AR', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    hourCycle: 'h23'
                  })
        return {Nombre: match2.Autorizadores.Persona.Apellido + " " + match2.Autorizadores.Persona?.Nombre, FechaHora: fechaHora, EsDelUsuario: esDelUsuario, DebeAutorizarAnterior: debeAutorizarAnterior, EsGeneral: esGeneral};
      }
      return {Nombre: null, FechaHora: null, EsDelUsuario: esDelUsuario, DebeAutorizarAnterior: debeAutorizarAnterior, EsGeneral: esGeneral};
    };
    
    const mostrarMenu = (event, submit, nroOrden, seDebeMostrar) => {
      //event.preventDefault()
      if(seDebeMostrar){
        submit.niveles[nroOrden].menuVisible = true
      }
    }

    const submitAutorizacion = async (estado, submit, nivel) => {
      try {
        // Asigna la versión limpia a form
        submit.niveles[nivel.NroOrden-1].loadingAutorizacion = true;
        let idEstado = estado.IdAutorizacionEstado
        let idSubmit = submit.IdSubmit
        let idNivel = nivel.IdAutorizadoresNivel
        
        let autorizador = form.value.AutorizadoresNivel
          .find(nivel => nivel.IdAutorizadoresNivel === idNivel) // encontrar el nivel específico
          ?.Autorizadores
          .find(a => a.IdPersona == user?.value.idPersona && a.Inhabilitado != true);     // encontrar la persona dentro de ese nivel
        
          
        // 1. Aplanar todos los arrays de 'Autorizadores' de cada nivel en una sola lista
        let todosLosAutorizadores = form.value.AutorizadoresNivel
            .flatMap(nivel => nivel.Autorizadores || []); // Usamos || [] para manejar niveles sin Autorizadores

        // 2. Luego, buscar en esa lista aplanada
        let autorizadorGral = todosLosAutorizadores
            .find(a => a.IdPersona == user?.value.idPersona && a.AutorizadorGeneral == true);

        if(!autorizador){
          autorizador = autorizadorGral;
        }

        if(idSubmit != null && autorizador != null && idEstado != null){
          let autorizacion = {
            IdAutorizacion: generarUUID(),
            IdAutorizadores: autorizador ? autorizador.IdAutorizadores : null,
            IdAutorizacionEstado: idEstado,
            IdSubmit: idSubmit,
            Comentario: null,
            FechaHora: new Date().toISOString()
          }
          
          await api.post(`api/Autorizaciones`, autorizacion);

          autorizacion = {
            ...autorizacion,
            AutorizacionEstado: estado,
            Autorizadores: autorizador
          }
          const index = submits.value.findIndex(s => s.IdSubmit === submit.IdSubmit);
          if (index !== -1) {
            const existingSubmit = submits.value[index];
            // Eliminar el submit existente
            submits.value.splice(index, 1);

            // Copiar autorizaciones anteriores y agregar la nueva
            const updatedAutorizaciones = [
              ...(existingSubmit.Autorizacion || []),
              JSON.parse(JSON.stringify(autorizacion))
            ];

            // Crear nuevo submit con la nueva Autorizacion
            const newSubmit = {
              ...submit,
              Autorizacion: updatedAutorizaciones
            };

            // Insertar el nuevo submit al final (o en la misma posición si querés)
            submits.value.push(newSubmit);
          }

          // Ordena los formularios según el sortKey
          submits.value.sort((a, b) => {
            let modifier = 1;
            if (sortKey.value === 'Nombre') {
              const creatorA = `${a?.IdEvaluadorNavigation?.Nombre} ${a?.IdEvaluadorNavigation?.Apellido}`;
              const creatorB = `${b?.IdEvaluadorNavigation?.Nombre} ${b?.IdEvaluadorNavigation?.Apellido}`;
              return modifier * creatorA.localeCompare(creatorB);
            } else if (sortKey.value === 'Fecha Desc') {
              return -1 * (new Date(a.FechaHora) - new Date(b.FechaHora));
            } else if (sortKey.value === 'Fecha Asc') {
              return 1 * (new Date(a.FechaHora) - new Date(b.FechaHora));
            } else {
              return -1 * (new Date(a.FechaHora) - new Date(b.FechaHora));
            }
          });

          submit.niveles[nivel.NroOrden-1].loadingAutorizacion = false;
          submit.niveles[nivel.NroOrden-1].menuVisible = false;
        }else{
          submit.niveles[nivel.NroOrden-1].loadingAutorizacion = false;
          submit.niveles[nivel.NroOrden-1].menuVisible = false;
          alert('Error: Valores vacios')
        }
      } catch (error) {
        console.error('Error al obtener formularios:', error);
        submit.niveles[nivel.NroOrden-1].loadingAutorizacion = false;
        submit.niveles[nivel.NroOrden-1].menuVisible = false;
      }
    };

    const generarUUID = () => {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }

    const isLink = (value) => {
      const urlPattern = /^(http|https):\/\/[^\s$.?#].[^\s]*$/; // Patrón simple para detectar URLs
      return urlPattern.test(value);
    };
    const toggleShareMenu = (id) => {
      showShareMenu.value = showShareMenu.value === id ? null : id;
      urlCompartir.value = `${window.location.href.split('#')[0]}#/formularios/completar?idForm=${id}`;
      urlCompartirResponder.value = `${window.location.href.split('#')[0]}#/formularios/responder?idForm=${id}`;
    };

    const closeShareMenu = () => {
      showShareMenu.value = null;
    };
    const toggleAccessMenu = () => {
      showAccessMenu.value = showAccessMenu.value === false ? true : false;
      accesoFormulario.value.IdFormulario = "";
      accesoFormulario.value.IdPersona = "";
      accesoFormulario.value.TipoPermiso = "";
    };

    const editForm = (idFormulario) => {
      router.push(`/formularios/edit?idForm=${idFormulario}`);
    };

    // Método para alternar entre los divs
    const toggleResults = (buttonNumber) => {
      isFirstDivVisible.value = buttonNumber === 1;

      localStorage.setItem("isFirstDivVisible", isFirstDivVisible.value)
      //Si se apreta el boton de graficos los vuelve a dibujar asi el usuario los ve.
      if(isFirstDivVisible.value){
        let i = 0;
        //Se excluyen las observaciones con Evaluado y Archivo
        var obsTemp = form.value.Observacions.filter(obs => obs.IdTipoObservacion !== '989bec4b-779d-41b0-8b28-1f1487b59ded' && obs.IdTipoObservacion !== 'bb1c6568-f8ea-42bc-9133-375f86fa2415')
        obsTemp.forEach( observacion => {
          drawChart(observacion, i, 'bar', 'x');
          i = i+1;
        })
      }
    }


    const deleteForm = async (id) => {
      try {
        await api.delete(`api/Formularios/ById`, {
          params: { id: id },
        });
        await router.push('/formularios');
      } catch (error) {
        console.error('Error al obtener formularios:', error);
      }
    };
    const closeDeleteMenu = () => {
      showDeleteMenu.value = false;
    };
    const copyLink = (id) => {
      urlCompartir.value = `${window.location.href.split('#')[0]}#/formularios/completar?idForm=${id}`;
      navigator.clipboard.writeText(urlCompartir.value).then(() => {
        //alert('Enlace copiado al portapapeles');
        closeShareMenu();
      });
    };
    const copyLinkResponder = (id) => {
      urlCompartirResponder.value = `${window.location.href.split('#')[0]}#/formularios/responder?idForm=${id}`;
      navigator.clipboard.writeText(urlCompartirResponder.value).then(() => {
        //alert('Enlace copiado al portapapeles');
        closeShareMenu();
      });
    };
    
    const deleteSubmit = async (id) => {
      try {
        await api.delete(`api/Valores/ByIdSubmit`, {
          params: { id: id },
        });
        await fetchForm();
      } catch (error) {
        console.error('Error al obtener formularios:', error);
      }
    };

    const fetchGrupos = async () => {
      try {
        loadingListas.value = true;
        const response = await api.get(`api/Grupos`);
        
        response.data.forEach(grupo =>{
          grupo.Listas.forEach(opcion =>{
            gruposDisponibles.value.push({
              IdLista: opcion.IdLista,
              Nombre: grupo?.Nombre + ' -> ' + opcion?.Nombre
            })
          })
        })
        //console.log(gruposDisponibles.value)
        loadingListas.value = false;
      } catch (error) {
        loadingListas.value = false;
        console.error('Error al obtener los tipos de observación:', error);
      }
    };

    const fetchForm = async () => {
      try {
          loading.value = true;
          const response = await api.get(`api/Formularios/ByIdBasicoVer`, {
              params: {
                  id: idForm
              },
          });
          let TempForm = response.data.Formulario;
          
          userPermission.value = response.data.TipoPermiso;
          
          //Se excluyen las observaciones con Evaluado y Archivo para los Graficos
          await getSubmits(TempForm, 1)
          
          if(userPermission.value == "Editor"){
            const response = await api.get(`api/Accesos/AccesosByIdForm`, {
                params: {
                    id: idForm
                },
            });
            console.log(userPermission.value)
            form.value.AccesoFormularios = response.data;
          }
          
          console.log(form.value)
          loading.value = false;
      } catch (error) {
        if (error.response) {
          console.error('Error al obtener formularios:', error);
          loading.value = false;
          //Forbidden: no debe acceder al form
          if(error.status=="403"){
            await router.push('/formularios');
          }
          errorForm.value = true
        } else if (error.request) {
          await router.push('/error');
        }
      }
    };

    
    const getSubmits = async (TempForm, page) => {
      try {
          loading.value = true;
          if (timeoutId) {
            clearTimeout(timeoutId);
          }
          
          let response2 = await api.get(`api/Valores/ByIdForm`, {
            params: {
              id: idForm,
              valorDeOrden: sortKey.value,
              fechaIni: fechaDesde.value,
              fechaFin: fechaHasta.value,
              page: page,
              estadoFiltro: estadoVisible.value,
              searchValue: search.value
            },
          });
          console.log(response2.data.Submits)

          totalPages.value = response2.data.TotalCount

          submits.value = response2.data.Submits.map(submit => {
            const nivelesCount = TempForm?.AutorizadoresNivel.length || 0;
            return {
              ...submit,
              niveles: Array.from({ length: nivelesCount }, () => ({
                menuVisible: false,
                loadingAutorizacion: false
              }))
            };
          });

          TempForm.Observacions.forEach((observacion) => {
            submits.value.forEach((submit) => {
              observacion.IsChartInProgress = false;
              // Aquí es donde se agregan los valores correspondientes de la respuesta
              const valorEncontrado = submit.Valores.find(o => o.IdObservacion === observacion.IdObservacion);
              if (valorEncontrado) {
                valorEncontrado.observacion = {
                    ...observacion,
                    Valores: []  // Podés vaciarlo sin afectar el original
                  };
                // Clonamos el objeto para no modificar el original
                const observacionValor = JSON.parse(JSON.stringify(valorEncontrado));
                
                observacionValor.Submit = {
                  ...submit,
                  Valores: []  // Podés vaciarlo sin afectar el original
                };
                observacion.Valores.push(observacionValor);
              }
            });
          });

          const niveles = TempForm.AutorizadoresNivel?.filter(an =>
            an.Autorizadores?.some(a => a.IdPersona === user?.value.idPersona)
          ) || []

          const todosLosEstados = niveles.flatMap(nivel => nivel.Estados || [])

          estados.value = Array.from(
            new Map(todosLosEstados.map(e => [e.EstadoNombre, e])).values()
          )
          
          //console.log(form.value)
          loading.value = false;
          form.value = TempForm
      } catch (error) {
        console.error('Error al obtener formularios:', error);
        loading.value = false;
      }
    };

    const disableButtons = (disable) => {
      // Aquí puedes deshabilitar los botones del UI
      const buttons = document.querySelectorAll('.chart-button'); // Reemplaza con el selector de tus botones
      buttons.forEach(button => {
        button.disabled = disable;
      });
    };

    const drawChart = async (observacion, index, typeOfChart, indexAxis, fill) => {
      await nextTick(); // Espera a que el DOM esté actualizado
      if(!typeOfChart){
        typeOfChart='bar'
      }
      if(!indexAxis){
        indexAxis='x'
      }
      if(fill==null){
        fill=false
      }
      //Si es del tipo Evaluado, no dibujar el grafico
      if (observacion.IdTipoObservacion=='989bec4b-779d-41b0-8b28-1f1487b59ded') {
          return;
      }
      if (observacion.IsChartInProgress) {
          return;
      }

      // Marcar que estamos procesando el gráfico
      observacion.IsChartInProgress = true;
      disableButtons(true);
      const canvasId = 'observacionChart-' + index//observacion.IdObservacion;
      const canvasElement = document.getElementById(canvasId);
      if (!canvasElement) {
          console.error(`El canvas con ID ${canvasId} no se encontró.`);
          return; // Salir de la función si el canvas no existe
      }
      const ctx = canvasElement.getContext('2d');

      // Asegurarse de que el gráfico actual se destruya antes de crear uno nuevo
      if (charts.value[index]) {
        charts.value[index].destroy(); // Destruye la instancia previa del gráfico
        charts.value[index] = null; // Liberar completamente la referencia
      }

      // Obtén los valores únicos y cuenta las ocurrencias de cada valor
      const uniqueValues = [...new Set(observacion.Valores.map(v => v.ValorObservado))];
      const dataCounts = uniqueValues.map(valor => getValueCount(observacion, valor));

      let minRange, maxRange, stepValue;

      // Genera las etiquetas y cuenta la cantidad de cada opción
      const optionLabels = observacion.ItemsObservacions.map(item => item.NombreItem);
      const optionCounts = optionLabels.map(label =>
        observacion.Valores.filter(valor => valor.ValorObservado === label).length
      );
      if(ctx){
        switch (observacion.IdTipoObservacionNavigation.tipoObservacion) {
          case 'Condicion Observada':
            // Crea un nuevo gráfico
            charts.value[index] = new Chart(ctx, {
              type: typeOfChart,
              data: {
                labels: ['Si', 'No', 'No Observable'],
                datasets: [{
                  label: observacion.NombreObservacion,
                  data: [
                    getValueCount(observacion, 'Si'),
                    getValueCount(observacion, 'No'),
                    getValueCount(observacion, 'No Observable')
                  ],
                  fill: fill, // Activar el relleno bajo la línea
                  backgroundColor: typeOfChart === 'line' ? 'rgba(255, 99, 132, 0.5)' : ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40', '#C9CBCF', '#84D8E0', '#FF8C94', '#FFA07A', '#8FBC8F'],
                  pointRadius: 8,
                  borderColor: 'rgba(180, 180, 180, 0.8)', // Gris claro
                  borderWidth: typeOfChart === 'line' ? 4 : 0,
                  pointBorderWidth: 0,
                  pointBackgroundColor: ['rgba(255, 99, 132, 1)', 'rgba(54, 162, 235, 1)', 'rgba(255, 206, 86, 1)', 'rgba(75, 192, 192, 1)', 'rgba(153, 102, 255, 1)', 'rgba(255, 159, 64, 1)', 'rgba(201, 203, 207, 1)', 'rgba(132, 216, 224, 1)', 'rgba(255, 140, 148, 1)', 'rgba(255, 160, 122, 1)',  'rgba(143, 188, 143, 1)'],
                }],
              },
              options: {
                plugins: {
                  legend: {
                    display: (typeOfChart === 'pie' || typeOfChart === 'doughnut') ? true : false
                  }
                },
                indexAxis: indexAxis,
                responsive: true,
                maintainAspectRatio: false,
                animation: {
                    duration: 250,  // Duración de la animación en milisegundos
                    easing: 'easeOutQuad',  // Tipo de easing
                },
                scales: {
                  y: {
                    beginAtZero: true,
                    max: Math.max(...[
                      getValueCount(observacion, 'Si'),
                      getValueCount(observacion, 'No'),
                      getValueCount(observacion, 'No Observable')
                    ]) + 1, // Agrega un margen de 2 unidades por encima del valor máximo
                    ticks: {
                      stepSize: 1
                    }
                  }
                }
              },
            });
            break;
          case 'Listas':
            // Crea el gráfico utilizando los labels y counts generados
            charts.value[index] = new Chart(ctx, {
              type: typeOfChart,
              data: {
                labels: optionLabels,
                datasets: [{
                  label: observacion.NombreObservacion,
                  data: optionCounts,
                  fill: fill, // Activar el relleno bajo la línea
                  backgroundColor: typeOfChart === 'line' ? 'rgba(255, 99, 132, 0.5)' : ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40', '#C9CBCF', '#84D8E0', '#FF8C94', '#FFA07A', '#8FBC8F'],
                  pointRadius: 8,
                  borderColor: 'rgba(180, 180, 180, 0.8)', // Gris claro
                  borderWidth: typeOfChart === 'line' ? 4 : 0,
                  pointBorderWidth: 0,
                  pointBackgroundColor: ['rgba(255, 99, 132, 1)', 'rgba(54, 162, 235, 1)', 'rgba(255, 206, 86, 1)', 'rgba(75, 192, 192, 1)', 'rgba(153, 102, 255, 1)', 'rgba(255, 159, 64, 1)', 'rgba(201, 203, 207, 1)', 'rgba(132, 216, 224, 1)', 'rgba(255, 140, 148, 1)', 'rgba(255, 160, 122, 1)',  'rgba(143, 188, 143, 1)'],
                }],
              },
              options: {
                plugins: {
                  legend: {
                    display: (typeOfChart === 'pie' || typeOfChart === 'doughnut') ? true : false
                  }
                },
                indexAxis: indexAxis,
                responsive: true,
                maintainAspectRatio: false,
                animation: {
                    duration: 250,  // Duración de la animación en milisegundos
                    easing: 'easeOutQuad',  // Tipo de easing
                },
                scales: {
                  y: {
                    beginAtZero: true,
                    max: Math.max(...optionCounts)+1,
                    ticks: {
                      stepSize: 1
                    }
                  }
                }
              },
            });
            break;
          case 'Rango':

            // Obtener los valores de Minimo, Maxima y StepValue
            for (let item of observacion.ItemsObservacions) {
              switch (item.NombreItem) {
                case 'Minimo':
                  minRange = item.ValorDeRango;
                  break;
                case 'Maxima':
                  maxRange = item.ValorDeRango;
                  break;
                case 'StepValue':
                  stepValue = item.ValorDeRango;
                  break;
              }
            }

            // Verificar que minRange, maxRange y stepValue tengan valores válidos
            if (minRange !== undefined && maxRange !== undefined && stepValue !== undefined) {
              // Crear un array para los valores dentro del rango
              const rangeValues = [];
              for (let value = minRange; value <= maxRange; value += stepValue) {
                rangeValues.push(value);
              }

              // Generar el dataset usando la función getValueCount
              const dataCounts = rangeValues.map(value => getValueCount(observacion, value.toString()));

              // Crear el gráfico usando los datos generados
              charts.value[index] = new Chart(ctx, {
                type: typeOfChart,
                data: {
                  labels: rangeValues, // Usar los valores del rango como etiquetas
                  datasets: [{
                    label: observacion.NombreObservacion,
                    data: dataCounts, // Utilizar los datos generados con getValueCount
                    fill: fill, // Activar el relleno bajo la línea
                    backgroundColor: typeOfChart === 'line' ? 'rgba(255, 99, 132, 0.5)' : ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40', '#C9CBCF', '#84D8E0', '#FF8C94', '#FFA07A', '#8FBC8F'],
                  pointRadius: 8,
                  borderColor: 'rgba(180, 180, 180, 0.8)', // Gris claro
                  borderWidth: typeOfChart === 'line' ? 4 : 0,
                  pointBorderWidth: 0,
                  pointBackgroundColor: ['rgba(255, 99, 132, 1)', 'rgba(54, 162, 235, 1)', 'rgba(255, 206, 86, 1)', 'rgba(75, 192, 192, 1)', 'rgba(153, 102, 255, 1)', 'rgba(255, 159, 64, 1)', 'rgba(201, 203, 207, 1)', 'rgba(132, 216, 224, 1)', 'rgba(255, 140, 148, 1)', 'rgba(255, 160, 122, 1)',  'rgba(143, 188, 143, 1)'],
                  }],
                },
                options: {
                  plugins: {
                    legend: {
                      display: (typeOfChart === 'pie' || typeOfChart === 'doughnut') ? true : false
                    }
                  },
                  indexAxis: indexAxis,
                  responsive: true,
                  maintainAspectRatio: false,
                  animation: {
                      duration: 250,  // Duración de la animación en milisegundos
                      easing: 'easeOutQuad',  // Tipo de easing
                  },
                  scales: indexAxis === 'x' ? { // Configuración para gráficos horizontales (eje X como índice principal)
                    y: {
                      beginAtZero: true,
                      max: Math.max(...dataCounts) + 1,
                      ticks: {
                        stepSize: 1
                      }
                    }
                  }
                  : { // Configuración para gráficos verticales (eje Y como índice principal)
                    x: {
                      beginAtZero: true,
                      max: Math.max(...dataCounts) + 1,
                      ticks: {
                        stepSize: 1
                      }
                    }
                  }
                },
              });
            }
            break;
          case 'Hora':
            // Crea un nuevo gráfico
            charts.value[index] = new Chart(ctx, {
              type: typeOfChart,
              data: {
                labels: uniqueValues,
                datasets: [{
                  label: observacion.NombreObservacion,
                  data: dataCounts,
                  fill: fill, // Activar el relleno bajo la línea
                  backgroundColor: typeOfChart === 'line' ? 'rgba(255, 99, 132, 0.5)' : ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40', '#C9CBCF', '#84D8E0', '#FF8C94', '#FFA07A', '#8FBC8F'],
                  pointRadius: 8,
                  borderColor: 'rgba(180, 180, 180, 0.8)', // Gris claro
                  borderWidth: typeOfChart === 'line' ? 4 : 0,
                  pointBorderWidth: 0,
                  pointBackgroundColor: ['rgba(255, 99, 132, 1)', 'rgba(54, 162, 235, 1)', 'rgba(255, 206, 86, 1)', 'rgba(75, 192, 192, 1)', 'rgba(153, 102, 255, 1)', 'rgba(255, 159, 64, 1)', 'rgba(201, 203, 207, 1)', 'rgba(132, 216, 224, 1)', 'rgba(255, 140, 148, 1)', 'rgba(255, 160, 122, 1)',  'rgba(143, 188, 143, 1)'],
                }],
              },
              options: {
                plugins: {
                  legend: {
                    display: (typeOfChart === 'pie' || typeOfChart === 'doughnut') ? true : false
                  }
                },
                indexAxis: indexAxis,
                responsive: true,
                maintainAspectRatio: false,
                animation: {
                    duration: 250,  // Duración de la animación en milisegundos
                    easing: 'easeOutQuad',  // Tipo de easing
                },
                scales: {
                  y: {
                    beginAtZero: true,
                    max: Math.max(...dataCounts)+1,
                    ticks: {
                      stepSize: 1
                    }
                  }
                }
              },
            });
            break;
          case 'Fecha':
            // Crea un nuevo gráfico
            charts.value[index] = new Chart(ctx, {
              type: typeOfChart,
              data: {
                labels: uniqueValues,
                datasets: [{
                  label: observacion.NombreObservacion,
                  data: dataCounts,
                  fill: fill, // Activar el relleno bajo la línea
                  backgroundColor: typeOfChart === 'line' ? 'rgba(255, 99, 132, 0.5)' : ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40', '#C9CBCF', '#84D8E0', '#FF8C94', '#FFA07A', '#8FBC8F'],
                  pointRadius: 8,
                  borderColor: 'rgba(180, 180, 180, 0.8)', // Gris claro
                  borderWidth: typeOfChart === 'line' ? 4 : 0,
                  pointBorderWidth: 0,
                  pointBackgroundColor: ['rgba(255, 99, 132, 1)', 'rgba(54, 162, 235, 1)', 'rgba(255, 206, 86, 1)', 'rgba(75, 192, 192, 1)', 'rgba(153, 102, 255, 1)', 'rgba(255, 159, 64, 1)', 'rgba(201, 203, 207, 1)', 'rgba(132, 216, 224, 1)', 'rgba(255, 140, 148, 1)', 'rgba(255, 160, 122, 1)',  'rgba(143, 188, 143, 1)'],
                }],
              },
              options: {
                plugins: {
                  legend: {
                    display: (typeOfChart === 'pie' || typeOfChart === 'doughnut') ? true : false
                  }
                },
                indexAxis: indexAxis,
                responsive: true,
                maintainAspectRatio: false,
                animation: {
                    duration: 250,  // Duración de la animación en milisegundos
                    easing: 'easeOutQuad',  // Tipo de easing
                },
                scales: {
                  y: {
                    beginAtZero: true,
                    max: Math.max(...dataCounts)+1,
                    ticks: {
                      stepSize: 1
                    }
                  }
                }
              },
            });
            break;
          case 'Texto Corto':
            // Crea un nuevo gráfico
            charts.value[index] = new Chart(ctx, {
              type: typeOfChart,
              data: {
                labels: uniqueValues,
                datasets: [{
                  label: observacion.NombreObservacion,
                  data: dataCounts,
                  fill: fill, // Activar el relleno bajo la línea
                  backgroundColor: typeOfChart === 'line' ? 'rgba(255, 99, 132, 0.5)' : ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40', '#C9CBCF', '#84D8E0', '#FF8C94', '#FFA07A', '#8FBC8F'],
                  pointRadius: 8,
                  borderColor: 'rgba(180, 180, 180, 0.8)', // Gris claro
                  borderWidth: typeOfChart === 'line' ? 4 : 0,
                  pointBorderWidth: 0,
                  pointBackgroundColor: ['rgba(255, 99, 132, 1)', 'rgba(54, 162, 235, 1)', 'rgba(255, 206, 86, 1)', 'rgba(75, 192, 192, 1)', 'rgba(153, 102, 255, 1)', 'rgba(255, 159, 64, 1)', 'rgba(201, 203, 207, 1)', 'rgba(132, 216, 224, 1)', 'rgba(255, 140, 148, 1)', 'rgba(255, 160, 122, 1)',  'rgba(143, 188, 143, 1)'],
                }],
              },
              options: {
                plugins: {
                  legend: {
                    display: (typeOfChart === 'pie' || typeOfChart === 'doughnut') ? true : false
                  }
                },
                indexAxis: indexAxis,
                responsive: true,
                maintainAspectRatio: false,
                animation: {
                    duration: 250,  // Duración de la animación en milisegundos
                    easing: 'easeOutQuad',  // Tipo de easing
                },
                scales: {
                  y: {
                    beginAtZero: true,
                    max: Math.max(...dataCounts)+1,
                    ticks: {
                      stepSize: 1
                    }
                  }
                }
              },
            });
            break;
        }
      }
      setTimeout(() => {
        observacion.IsChartInProgress = false;
        disableButtons(false);
      }, 600); // 2000 ms = 2 segundos
    };


    const getValueCount = (observacion, valor) => {
      return observacion.Valores.filter(v => v.ValorObservado === valor).length;
    };

    // Obtener los tipos de observación desde la API
    const fetchGruposResponsables = async () => {
      try {
        let response = await api.get(`api/Grupos/by-responsable/`+user.value?.idPersona);
        grupos.value = response.data
      } catch (error) {
        console.error('Error al obtener los tipos de observación:', error);
      }
    };

    const chequearPermisosAutorizaciones = (nivel, IdPersonaSubmit) => {
      // Si el tipo de permiso es "Todos", la autorización es siempre permitida
      if (nivel.TipoPermiso == "Todos") {
        return true;
      }
      else {
        for (const grupo of grupos.value) {
          if (nivel.TipoPermiso === grupo?.Nombre && IdPersonaSubmit != null) {
            if (grupo.Listas[0].PersonasRelacionadas.some(s => s.IdPersona === IdPersonaSubmit)) {
              return true;
            }
          }
        }
      }
      // Si no cumple con las condiciones, denegar autorización
      return false;
    };


    // Obtener las personas para dar acceso
    const fetchPersonas = async () => {
      try {
        const response = await api.get(`api/Persona/ByRole?role=Empleado`);
        const idPersonaExcluida = user.value?.idPersona; // Reemplaza con el ID de la persona a excluir
        persona.value = response.data.filter(persona => persona.IdPersona !== idPersonaExcluida);
      } catch (error) {
        console.error('Error al obtener los tipos de observación:', error);
      }
    };

        // Filtrar personas basadas en el input de búsqueda
    const filterPersonas = () => {
      if (searchQuery.value == '') {
        filteredPersonas.value = [];
      } else {
        const query = searchQuery.value.toLowerCase();
        filteredPersonas.value = persona.value.filter(evaluado => {
          const nombreCompleto = `${evaluado.Apellido} ${evaluado?.Nombre}`.toLowerCase();
          const correo = evaluado.Email && evaluado.Email.length > 0 ? evaluado.Email[0].email.toLowerCase() : '';

          return nombreCompleto.includes(query.toLowerCase()) || correo.includes(query.toLowerCase());
        }).slice(0, 10);
      }
    };
    const selectPersona = (evaluado) => {
      selectedPersona.value = evaluado.IdPersona; // Asigna la persona seleccionada
      //fetchAsignaturas();
      searchQuery.value = `${evaluado.Apellido} ${evaluado?.Nombre}`; // Muestra el nombre en el input
      filteredPersonas.value = []; // Limpia la lista filtrada
    };
    const filterLista = () => {
      if (searchQuery.value === '') {
        filteredLista.value = [];
        return; // Salir si la búsqueda está vacía
      }

      const query = searchQuery.value;
      const lowerCaseQuery = query.toLowerCase();
      
      // Dividir la consulta en palabras individuales
      const queryWords = lowerCaseQuery.split(' ').filter(word => word.length > 0);

      // Paso 1: Filtrar y priorizar coincidencias exactas (case-sensitive)
      const exactMatches = gruposDisponibles.value.filter(opcionGrupo => {
        return opcionGrupo?.Nombre.includes(query);
      });

      // Paso 2: Filtrar coincidencias (case-insensitive) y por palabras individuales
      const otherMatches = gruposDisponibles.value.filter(opcionGrupo => {
        const nombreLowerCase = opcionGrupo?.Nombre.toLowerCase();
        
        // Evitar duplicados con las coincidencias exactas
        if (exactMatches.includes(opcionGrupo)) {
          return false;
        }

        // Buscar si el nombre incluye la consulta completa (case-insensitive)
        if (nombreLowerCase.includes(lowerCaseQuery)) {
          return true;
        }

        // Buscar si el nombre incluye TODAS las palabras individuales de la consulta
        return queryWords.every(word => nombreLowerCase.includes(word));
      });

      // Paso 3: Combinar y ordenar los resultados
      const combinedResults = [...exactMatches, ...otherMatches];

      // Si quieres limitar el número de resultados, aplica slice aquí
      //filteredLista.value = combinedResults.slice(0, 10);
      filteredLista.value = combinedResults;
    };
    const selectLista = (opcionGrupo) => {
      selectedLista.value = opcionGrupo.IdLista; // Asigna la persona seleccionada
      //fetchAsignaturas();
      searchQuery.value = `${opcionGrupo?.Nombre}`; // Muestra el nombre en el input
      filteredLista.value = []; // Limpia la lista filtrada
    };
    //Le da ACCESO al formulario a X persona
    const submit = async () => {
      try {
        loadingSubmitAcceso.value = true;  // Mostrar el cargador
        accesoFormulario.value.IdFormulario = form.value.IdFormulario
        accesoFormulario.value.IdLista = selectedLista.value
        accesoFormulario.value.IdPersona = selectedPersona.value
        accesoFormulario.value.TipoPermiso = tipoPermiso.value
        const response = await api.post(`api/Accesos/DarAccesoForm`, JSON.stringify(accesoFormulario.value), {
          params: {
            conEnvio: conEnvio.value,
          },
        });

        if (response.status === 500) {
          throw new Error('Error interno en el Servidor.');
        }
        selectedLista.value = null;
        selectedPersona.value = null;
        fetchForm();
        searchQuery.value = '';
      } catch (error) {
        loadingSubmitAcceso.value = false; // Detener el cargador
        if (error.response && error.response.status === 409) {
          errorMessage.value = error.response.data;
        } else {
          errorMessage.value = "Ocurrió un error inesperado. Por favor, intente de nuevo más tarde.";
        }
      } finally {
        loadingSubmitAcceso.value = false;  // Detener el cargador
      }
    };

    const actualizarAcceso = async (acceso) => {
      try {
        const response = await api.put(`api/Accesos/DarAccesoForm`, JSON.stringify(acceso));

        if (response.status === 500) {
          throw new Error('Error interno en el Servidor.');
        }
        fetchForm();
      } catch (error) {
        loadingSubmitAcceso.value = false; // Detener el cargador
        if (error.response && error.response.status === 409) {
          alert(error.response.data)
        } else {
          alert("Ocurrió un error inesperado. Por favor, intente de nuevo más tarde.")
        }
      }
    };

    const deleteAcceso = async (acceso) => {
      try {
        await api.delete(`api/Accesos/DarAccesoForm`,  {
           data: JSON.stringify(acceso),
        });
        fetchForm();
      } catch (error) {
        console.error('Error al obtener formularios:', error);
      }
    };


    const formatDateTime = (date) => {
      return new Date(date).toLocaleDateString('es-ES', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit', // Opcional, si quieres incluir los segundos
        hour12: false, // Para usar el formato de 24 horas
      });
    };

    // Función para descargar el archivo CSV
    const downloadCsvForm = async () => {
      loading.value = true;  // Mostrar el spinner de carga

      try {
        // Hacer la solicitud para obtener los datos CSV desde la API
        const response = await api.get(`api/Formularios/ExcelResults`, {
          params: {
            id: form.value.IdFormulario,
          },
          responseType: 'blob',  // Asegurarse de que el contenido sea tratado como un archivo binario
        });

        // Crear un enlace para descargar el archivo CSV
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${form.value.NombreFormulario.trimEnd()}.csv`);  // Nombre del archivo a descargar
        document.body.appendChild(link);
        link.click();  // Simular clic en el enlace para iniciar la descarga
        link.remove();
      } catch (error) {
        console.error("Error al descargar el archivo CSV:", error);
      } finally {
        loading.value = false;  // Ocultar el spinner de carga
      }
    };

    const formatDescription = (text) => {
      if (!text) return '';

      // Placeholder for existing links
      const existingLinks = [];
      let placeholderIndex = 0;

      // Regex to find existing <a> tags, capturing the full tag
      const findAndStoreLinksRegex = /<a[^>]*href=["'][^"']+\.[^"']+\.[^"']+(?:[^"']+)*["'][^>]*>.*?<\/a>/gi;

      // Step 1: Temporarily replace existing <a> tags with placeholders
      // This also handles your specific case where the URL inside href is interpolated
      let processedText = text.replace(findAndStoreLinksRegex, (match) => {
        const placeholder = `__LINK_PLACEHOLDER_${placeholderIndex}__`;
        existingLinks.push({ placeholder, original: match });
        placeholderIndex++;
        return placeholder;
      });

      // Regular expression to find URLs in the remaining plain text
      // This regex is now simpler as it only needs to look for standalone URLs
      const urlRegex = /(https?:\/\/[^\s]+)/g;

      // Step 2: Replace standalone URLs in the processed text
      processedText = processedText.replace(urlRegex, (url) => {
        // Ensure the URL isn't part of an existing placeholder's original content (redundant check but safe)
        const isAlreadyLinkedByPlaceholder = existingLinks.some(link => link.original.includes(url));
        if (isAlreadyLinkedByPlaceholder) {
          return url; // Should ideally not happen if placeholders work correctly
        }
        return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
      });

      // Step 3: Put the original <a> tags back in their place
      existingLinks.forEach(({ placeholder, original }) => {
        processedText = processedText.replace(placeholder, original);
      });

      return processedText;
    };
    
    onBeforeUnmount(() => {
      if (connection) {
        connection.stop();
      }
    });

    onMounted(async() => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0]; // Obtiene solo la fecha (YYYY-MM-DD)
      localStorage.removeItem('redirectAfterLogin')

      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload(); // Recarga la página solo si no se ha recargado hoy
      }
      checkAuth();

      connection = new signalR.HubConnectionBuilder()
        .withUrl(`${API_BASE_URL}hubs/formulario`)
        .withAutomaticReconnect()
        .build();

      connection
        .start()
        .then(() => {
          console.log("✅ Conectado a SignalR");
        })
        .catch((err) => {
          console.error("❌ Error al conectar a SignalR", err);
        });

      connection.on("FormularioActualizado", (idFormulario) => {
        console.log("🆕 Formulario actualizado:", idFormulario);
        fetchForm();
      });

      connection.onclose(() => {
        console.log("Conexión perdida, intentando reconectar...");
        // opcional: reconectar automáticamente
      });

      isFirstDivVisible.value = localStorage.getItem("isFirstDivVisible") === "true"
      await fetchForm();
      await fetchGruposResponsables();
      await fetchPersonas();
      await fetchGrupos();
    });

    return {
      search,
      form,
      persona,
      searchQuery,
      filteredPersonas,
      selectedPersona,
      filterPersonas,
      selectPersona,
      filteredLista,
      selectedLista,
      filterLista,
      selectLista,
      asignaturas,
      charts,
      drawChart,
      showShareMenu,
      showMenuFilter,
      toggleShareMenu,
      closeShareMenu,
      showAccessMenu,
      toggleAccessMenu,
      copyLink,
      copyLinkResponder,
      urlCompartir,
      urlCompartirResponder,
      deleteForm,
      closeDeleteMenu,
      loading,
      loadingSubmitAcceso,
      submit,
      tipoPermiso,
      userPermission,
      errorMessage,
      deleteAcceso,
      showDeleteMenu,
      editForm,
      formatDateTime,
      t,
      isLink,
      submits,
      toggleResults,
      isFirstDivVisible,
      downloadCsvForm,
      conEnvio,
      actualizarAcceso,
      user,
      deleteSubmit,
      hasAdminForms,
      autorizacionNivel,
      nombreAutorizadorGrupo,
      chequearPermisosAutorizaciones,
      sortKey,
      filteredSubmits,
      fechaDesde,
      fechaHasta,
      estados,
      estadoVisible,
      mostrarMenu,
      submitAutorizacion,
      idForm,
      tipoAcceso,
      gruposDisponibles,
      loadingListas,
      addRedirectUrl,
      formatDescription,
      habilitarFormulario,
      nextPage,
      prevPage,
      totalPages,
      currentPage,
      getSubmits,
      filterSubmits,
      errorForm
    };
  },
};
</script>

<style scoped>

.chart-canvas {
  width: 100% !important; /* Asegúrate de que ocupe todo el ancho */
  max-height: 400px; /* Establece una altura fija */
}

.custom-context-menu {
  /* Estilo para el menú */
  min-width: 120px;
  border: 1px solid var(--fondo-secundario);
  border-radius: 4px;
  position: absolute;
  z-index: 10;
}

.overlay-2 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);  /* Fondo semitransparente */
  z-index: 5;  /* Coloca la capa por debajo del menú */
}

</style>
